import { Box } from "@mui/system";
import React, { useRef, useState } from "react";
import cssClasses from "./Payments.module.css";
import cssClasses2 from "../../Components/AllAllotments/AllAllotments.module.css";
import CustomInput from "../../Subcomponents/CustomInput";
import TabContext from "@mui/lab/TabContext";
import TabsMenu from "../../Subcomponents/TabsMenu";
import TabPanel from "@mui/lab/TabPanel";
import PaymentDetails from "./PaymentDetails";
import NoPaymentsDonePng from "./NoPaymentsDone.png";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@mui/lab";
import DoneIcon from "@mui/icons-material/Done";
import { ReactQueryDevtools } from "react-query-devtools";
import {
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Slider,
  Modal,
  Checkbox,
  Tooltip,
  Card,
  ClickAwayListener,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../Subcomponents/Button";
import { errorTost, infoTost, successTost } from "../../Services/Toast";
import { Typography } from "@mui/material";
import Datagrid from "../../Subcomponents/Datagrid";
import DropDown from "../../Subcomponents/DropDown";
import SearchBar from "../../Subcomponents/Search";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import { useNavigate } from "react-router-dom";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import CircleIcon from "@mui/icons-material/Circle";
import { useEffect } from "react";
import {
  getAllotmentTransactions,
  getPayments,
  getTokenTransactions,
  getProjectList,
  getAllotmentTransactionsTimeline,
  getWingList,
} from "../../Services/Payments";
import {
  getAllotmentsFilter,
  getFilterNames,
} from "../../Services/AllAllotments";
import DropDownButton from "../../Subcomponents/DropDownButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
import Dot from "../../Components/Icons/Dot";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";

import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import RefundToken from "../../Modals/RefundToken/RefundToken";
import { getSpecificEventsTokenRefundRequests } from "../../Services/Event";
import { tokenRefundRequest } from "../../Services/Tokens";
import { updateLeadAllStatus } from "../../Services/Lead";
import { updateLeadTokenStatus } from "../../Services/AssignNewToken";
import { useSelector } from "react-redux";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { debounce, orderBy, sortBy, uniqBy } from "lodash";
import AssignNewToken from "../../Modals/AssignNewToken/AssignNewToken";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { supabase } from "../../supabaseClient";
import { makeStyles } from "@mui/styles";
import InfiniteScroll from "react-infinite-scroll-component";
import ServerPaginationGrid from "../../Components/ServerPaginationGrid";
import { QueryClient, QueryClientProvider } from "react-query";
import CheckBoxTreeView from "../../Components/CheckboxTreeView";
import CheckboxTreeView2 from "../../Components/CheckboxTreeView/CheckboxTreeView2";
import TreeviewCheckbox from "../../Components/TreeviewCheckbox";
import lodash from "lodash";
// import cssClasses from "../../";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { refundTokenPayment } from "../../Services/PaymentApi";
import AlotUnit from "../../Modals/AlotUnit/AlotUnit";
import AlotExistingUnit from "../../Modals/AlotExistingUnit/AlotExistingUnit";
import RefundAllotment from "../../Modals/RefundAllotmentAmount/RefundAllotment";
import TreeviewCheckboxBeta from "../../Components/TreeviewCheckbox/TreeviewCheckboxBeta";
import ViewToggleSwitch from "../../Subcomponents/ViewSwitch/ViewToggleSwitch";
import DateComponent from "../../Subcomponents/DateComponent";
import { DataGrid } from "@mui/x-data-grid";
import EmptyState from "../../Assets/Images/Common/noProjectFound.svg"
import * as XLSX from "xlsx";
import { autotagFromTransactionPayment, getAllTransactions, getAllTransactionsSummary, getTaggedTransactionTarget, getPendingDuesForLead, refundFromTransactionPayment } from "../../Services/Transactions";
import ManualTagModal from "../../Modals/ManualTag/ManualTagModal";
const useStyles = makeStyles((theme) => ({
  Grid: {
    "&.MuiGrid-item": {
      padding:
        window.innerWidth < 820
          ? "10px 1px !important"
          : "1px 0rem 2.4rem 2.4rem !important",
    },
  },
  Tabs: {
    "&.MuiTabPanel-root": {
      padding: "1rem 0rem 2rem 0rem !important",
    },
  },
}));

const dataGridStyles = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  border: "1px solid #EAECF0 !important",
  fontWeight: "400",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  color: "#667085",
  fontFamily: "Inter-Medium",
  borderRadius: "8px",
  '& div[data-colindex="1"]': {
    color: "#101828",
    fontWeight: "500",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #EAECF0",
      background: "#FFFFFF",
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: "1rem",

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      borderBottom: "1px solid #EAECF0",
      backgroundColor: "#FFFFFF",
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  "& .MuiDataGrid-iconSeparator ": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader:hover": {
    "& .MuiDataGrid-menuIcon": {
      visibility: "hidden",
    },
  },
  "& .MuiDataGrid-columnHeaders + div": {
    height: "calc(100vh - 315px) !important",
  },
  "&  .MuiDataGrid-columnHeaders": {
    background: "#F9FAFB",
    /* Gray/200 */
    border: "1px solid #EAECF0",
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: "1rem",
    borderBottom: "6px solid #EAECF0",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-checkboxInput": {
    "& svg": {
      width: "2rem",
      height: "2rem",
      background: "#FFFFFF",
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  "& .MuiDataGrid-footerContainer": {
    "& .MuiTablePagination-displayedRows ": {
      display: "none",
    },
    "& .MuiDataGrid-selectedRowCount": {
      visibility: "hidden ",
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: "none",
    cursor: "none",
  },
  "& [title='Go to previous page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to next page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: "1rem",
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: "1rem",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 4rem",

    "&:focus": {
      outline: "none",
    },
  },
  "&  .MuiDataGrid-row ": {
    maxHeight: "72px !important",
    minHeight: "72px !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 4rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "1.6rem",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 2rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 2rem",

    "&:focus": {
      outline: "none",
    },
  },
};
const Payment = () => {
  useEffect(() => {
    // getProjectList();

    const fetchEvents = async () => {
      const data = await getProjectList();
      setProjectList(data);
    };
    fetchEvents();
  }, []);

  const classes = useStyles();

  const [showDropDown, setShowDropDown] = React.useState(false);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [queryPage, setQueryPage] = useState(0);
  const [loadingStatus, setLoadingStatus] = useState(0);
  const [depStr, setDepQuery] = useState("");
  const [projectStr, setProjectStr] = useState({ p: [], w: [], f: [] });
  const [projectSelected, setProjectSelected] = useState([]);
  const [typeMode, setTypeMode] = useState("Card View");
  const [selectedCard, setSelectedCard] = useState({
    trRequest: {},
    viewDetails: {},
    assignNewToken: {},
  });

  const [searchValue, setSearchValue] = useState("");
  const [subTabs, setSubTabs] = useState([
    {
      text: "All",
      value: "All",
      isSelected: true,
      key: 0,
    },
    {
      text: "Pending",
      value: "Pending",
      isSelected: false,
    },
    {
      text: "On Hold",
      value: "On Hold",
      isSelected: false,
    },
    {
      text: "Completed",
      value: "Completed",
      isSelected: false,
    },
    {
      text: "Preselect",
      value: "Preselect",
      isSelected: false,
    },
  ]);
  function releaseUnit(allotment) {
    // console.log(allotment);
    // presentLoader();
    // if (allotment.pricingtype === "event") {
    //   supabase
    //     .from("EventTokenLeadRelations")
    //     .update({ status: "active" })
    //     .eq("paymentId", allotment.paymentid)
    //     .then((resp) => {
    //       supabase
    //         .from("LeadStatus")
    //         .update({ status: "Checkpoint Two Cleared" })
    //         .eq("leadId", allotment.leadid)
    //         .then((resp) => {
    //           let obj = {
    //             leadId: allotment.leadid,
    //             leadStatus: `Checkpoint Two Cleared`,
    //             message: `Unit Release`,
    //           };
    //           addLeadLogs(obj)
    //             .then((leadLog) => {
    //               console.log(leadLog);
    //             })
    //             .catch((err) => {
    //               console.log("leadlog", err);
    //             });
    //           changeAllotmentStatus(allotment);
    //         });
    //     });
    // } else {
    //   supabase
    //     .from("LeadStatus")
    //     .update({ status: "Site Visit Done" })
    //     .eq("leadId", allotment.leadid)
    //     .then((resp) => {
    //       let obj = {
    //         leadId: allotment.leadid,
    //         leadStatus: `Site Visit Done`,
    //         message: `Unit Release`,
    //       };
    //       addLeadLogs(obj)
    //         .then((leadLog) => {
    //           console.log(leadLog);
    //         })
    //         .catch((err) => {
    //           console.log("leadlog", err);
    //         });
    //       changeAllotmentStatus(allotment);
    //     });
    // }
  }
  function openModal(row) {
    // setCurrentAllotment(row);
    // setOpenPaymentModal(true);
  }

  function alotUnit(allotment) {
    // presentLoader();
    // supabase
    //   .from("LeadStatus")
    //   .update({ status: "Allotment Payment Pending" })
    //   .eq("leadId", allotment.leadid)
    //   .then((leadStatusRes) => {
    //     supabase
    //       .from("InventoryStatus")
    //       .select("*")
    //       .eq("status", "Payment Pending")
    //       .then((statusRes) => {
    //         axios
    //           .post(
    //             `${process.env.REACT_APP_PAYMENT_LINK_URL}bookings/send-payment-email`,
    //             {
    //               leadName: allotment.leadname,
    //               allotmentPaymentId: allotment.allotmentpaymentid,
    //               leadEmail: allotment.leademail,
    //             }
    //           )
    //           .then((reqRes) => {
    //             supabase
    //               .from("AllotmentPayment")
    //               .update({ status: "Payment Pending" })
    //               .eq("allotmentPaymentId", allotment.allotmentpaymentid)
    //               .then((paymentRes) => {
    //                 if (allotment.unitid) {
    //                   supabase
    //                     .from("Inventory")
    //                     .update({
    //                       inventoryStatusId:
    //                         statusRes.data[0].inventoryStatusId,
    //                     })
    //                     .eq("unitId", allotment.unitid)
    //                     .then((updateRes) => {
    //                       supabase
    //                         .from("InventoryLogs")
    //                         .insert({
    //                           unitId: allotment.unitid,
    //                           leadId: allotment.leadid,
    //                           userId: JSON.parse(localStorage.getItem("user"))
    //                             .userId,
    //                           status: "payment pending",
    //                           pricingType: allotment.pricingtype,
    //                         })
    //                         .then((updateRes) => {
    //                           dismissLoader();
    //                           getFilterAllotment();
    //                         });
    //                     });
    //                 } else {
    //                   supabase
    //                     .from("Inventory")
    //                     .update({
    //                       inventoryStatusId:
    //                         statusRes.data[0].inventoryStatusId,
    //                     })
    //                     .eq("unitId", allotment.unit1id)
    //                     .then((updateRes) => {
    //                       supabase
    //                         .from("InventoryLogs")
    //                         .insert({
    //                           unitId: allotment.unit1id,
    //                           leadId: allotment.leadid,
    //                           userId: JSON.parse(localStorage.getItem("user"))
    //                             .userId,
    //                           status: "payment pending",
    //                           pricingType: allotment.pricingtype,
    //                         })
    //                         .then((updateRes) => {
    //                           supabase
    //                             .from("Inventory")
    //                             .update({
    //                               inventoryStatusId:
    //                                 statusRes.data[0].inventoryStatusId,
    //                             })
    //                             .eq("unitId", allotment.unit2id)
    //                             .then((updateRes) => {
    //                               supabase
    //                                 .from("InventoryLogs")
    //                                 .insert({
    //                                   unitId: allotment.unit2id,
    //                                   leadId: allotment.leadid,
    //                                   userId: JSON.parse(
    //                                     localStorage.getItem("user")
    //                                   ).userId,
    //                                   status: "payment pending",
    //                                   pricingType: allotment.pricingtype,
    //                                 })
    //                                 .then((updateRes) => {
    //                                   dismissLoader();
    //                                   getFilterAllotment();
    //                                 });
    //                             });
    //                         });
    //                     });
    //                 }
    //               });
    //           });
    //       });
    //   });
  }
  async function selectedValueCheck(value, allotment, index) {
    setItemCount(allotment.value);
    if (openTab === "Tokens") setItemCount(index);
    setTokenTransaction([]);
    if (openTab === "Tokens") {
      if (value === "View Details") {
        setViewModal(true);
        let t = getTokenTransaction(allotment.paymentid);
      } else if (value === "Token Refund Request") {
        setRefundTokenModal(true);
        getSpecificEventsTokenRefundRequests(allotment.paymentid)
          .then((resp) => {
            let tokenObject = {
              tokenName: allotment.tokenname,
              amount: allotment.amount,
              paymentId: allotment.paymentid,
              TokenRefundRequests: resp.data,
              type: allotment.unittype,
              paidAmount: allotment.paidamount,
            };
            setRefundTokenData(tokenObject);
            let obj = {
              leadId: allotment.leadid,
              leadname: allotment.leadname,
            };
            setLeadObj(obj);
          })
          .catch((err) => {
            console.log(err);
          });
      } else if ("Assign New Token") {
        setAssignNewTokenModal(true);
        getSpecificEventsTokenRefundRequests(allotment.paymentid)
          .then((resp) => {
            let tokenObject = {
              ...allotment,
              tokenName: allotment.tokenname,
              amount: allotment.amount,
              paymentId: allotment.paymentid,
              TokenRefundRequests: resp.data,
            };
            setOldTokenData(tokenObject);
          })
          .catch((err) => {
            console.log(err);
          });
        setOldTokenData(allotment);
        let obj = {
          leadId: allotment?.leadid,
          leadname: allotment?.leadname,
          leadcontactnumber: allotment?.leadcontactnumber,
          leademail: allotment?.leademail,
        };
        setLeadObj(obj);
      }
    } else if (openTab === "Allotments") {
      getAT_Timeline(allotment.allotmentpaymentid);
      if (value === "View Details") {
        setViewModal(true);
        getAT_Timeline(allotment.allotmentpaymentid);
      } else if (value === "Initiate Refund") {
        let obj = {
          leadId: allotment?.leadid,
          leadname: allotment?.leadname,
          leadcontactnumber: allotment?.leadcontactnumber,
          leadDetails: {
            contactNumber: allotment?.leadcontactnumber,
            leadEmail: allotment?.leademail,
          },
          leademail: allotment?.leademail,
          leaddisplayid: allotment?.leaddisplayid,
        };
        let allotmentObject = {
          ...allotment,
          tokenName: allotment.tokenname,
          amount: allotment.amount,
          paymentId: allotment.paymentid,
        };
        setOldAllotmentData(allotmentObject);
        setLeadObj(obj);
        setOpenAlertBoxForCancellation(true);
      } else if (value === "Alot Unit") {
        let obj = {
          leadId: allotment?.leadid,
          leadname: allotment?.leadname,
          leadcontactnumber: allotment?.leadcontactnumber,
          leadDetails: {
            contactNumber: allotment?.leadcontactnumber,
            leadEmail: allotment?.leademail,
          },
          leademail: allotment?.leademail,
          leaddisplayid: allotment?.leaddisplayid,
        };
        let allotmentObject = {
          ...allotment,
          tokenName: allotment.tokenname,
          amount: allotment.amount,
          paymentId: allotment.paymentid,
        };
        setOldAllotmentData(allotmentObject);
        setLeadObj(obj);
        // setAlotUnitModal(true);
        setAlotExistingUnitModal(true);
        // ! vedashree changes for pbc event preselect rebooking
        sessionStorage.setItem('isPaymentTab', true)
      }
    }

    console.log("details", allotment?.paymentid);

  }
  function getList(allotment) {
    // let arr = ["Check Status"]
    // if (allotment.paidAmount > 0) {
    //   arr.push("Details")
    // }
    // if ((allotment?.pricingType !== 'preselect' && (allotment?.status === 'Payment Pending' || allotment?.status === 'Partial Payment Done') && subTabs.filter((ele) => { return ele.isSelected })[0]?.value === 'All')) {
    //   arr.push("Adjust Token")
    // }
    // if(allotment?.status!=='Released'&&allotment?.status!=='Cancelled'&&allotment?.status!=='Change Requested'&&allotment?.status!=='Change Rejected'&&allotment?.status!=='Cancellation Requested'&&allotment?.status!=='Cancellation Rejected'&&allotment?.status!=='Partial Payment Done'){
    //   // !!Remaining user access condition
    //   if(loggedInUser?.roleId?.accessibleTabs?.['All Allotments']?.['Cancel Unit']?.isAccessible){
    //     arr.push("Cancel Unit");
    //   }
    // }
    // return arr
    return openTab == "Tokens"
      ? allotment?.subMenu
      : allotment?.subMenuAllotment;
  }

  TimeAgo.setDefaultLocale(en.locale);
  TimeAgo.addLocale(en);
  const dispatch = useDispatch();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [open, setOpen] = useState(false);
  const [base, setBase] = useState("");
  const [planDetail, setPlanDetail] = useState({});
  const [viewModal, setViewModal] = useState(false);
  const [filterBy, setFilterBy] = useState("Latest First");
  const [lists, setLists] = useState([
    "Name Ascending",
    "Name Descending",
    "Oldest First",
    "Latest First",
  ]);
  const [plans, setPlans] = useState([]);
  const [range, setRange] = useState({
    from: 0,
    to: 9,
  });
  const [payment, setPayment] = useState([]);
  const [details, setDetails] = useState([]);
  const [itemCont, setItemCount] = useState();
  const [filterNames, setFilterNames] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterCheck, setFilterCheck] = useState("None");
  const [cp, setCp] = useState([]);
  const [events, setEvents] = useState([]);
  const [filter, setFilter] = useState("");
  const [salesRepresentative, setSalesRepresentative] = useState([]);
  const [inventoryTypes, setInventoryTypes] = useState([]);
  const [PaymentStatus, setPaymentStatus] = useState([]);
  const [AllotmentStatus, setAllotmentStatus] = useState([]);
  const [tokenTypes, setTokenTypes] = useState([]);
  const [showPriceRange, setShowPriceRange] = useState(false);
  const [showProjectList, setShowProjectList] = useState(false);
  const [projectList, setProjectList] = useState([]);

  const [value, setValue] = React.useState([1, 200]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [checked, setChecked] = useState([]);
  const [btnName, setBtnName] = useState("None");
  const [mainTabs, setMainTabs] = useState([
    // { text: "All", value: "All", isSelected: true, isCompleted: false },
    { text: "Tokens", value: "Tokens", isSelected: true, isCompleted: false },
    {
      text: "Allotments",
      value: "Allotments",
      isSelected: false,
      isCompleted: false,
    },
    loggedInUser?.roleId?.accessibleTabs?.["Payments"]
      ?.["Untagged Transactions"]?.isAccessible && {
      text: "Untagged Transactions",
      value: "Transactions",
      isSelected: false,
      isCompleted: false,
    },
  ]);
  const [all_prices, setAll_prices] = useState([]);
  const [openTab, setOpenTab] = useState("Tokens");
  const [tokenTransactions, setTokenTransaction] = useState([]);
  const [refundTokenModal, setRefundTokenModal] = useState(false);
  const [refundTokenData, setRefundTokenData] = useState(null);
  const [selectBulk, setSelectBulk] = useState(false);
  const [buttonName, setButtonName] = useState("Bulk Refund Request");
  const [bulkRequested, setBulkRequested] = useState(false);
  const [assignNewTokenModal, setAssignNewTokenModal] = useState(false);
  const [oldTokenData, setOldTokenData] = useState(null);
  const [oldAllotmentData, setOldAllotmentData] = useState(null);
  const [allotmentTransaction, setAllotmentTransaction] = useState([]);

  const [allotmentTransactions, setAllotmentTransactions] = useState([]);
  // !!Alert has been changed to modal
  const [openAlertBoxForCancellation, setOpenAlertBoxForCancellation] =
    useState(false);
  // const [openAlertBoxForCancellationNoTransactionsFound, setOpenAlertBoxForCancellationNoTransactionsFound] =useState(false);
  const [alotUnitModal, setAlotUnitModal] = useState(false);
  const [alotExistingUnitModal, setAlotExistingUnitModal] = useState(null);

  const [viewList] = useState([
    { id: 1, label: "Card View" },
    { id: 2, label: "Table View" },
  ]);
  const [view, setView] = useState("Card View");
  const [isTableView, setIsTableView] = useState(false);
  const [paymentCount, setPaymentCount] = useState(0);
  const [allotmentCount, setAllotmentCount] = useState(0);
  const [selectedRequestToInitiate, setSelectedRequestToInitiate] = useState(
    []
  );

  //transaction tab state
  const [filterByTransaction, setFilerByTransaction] = useState("Latest First");
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  const [isEndDateNotNull, setIsEndDateNotNull] = useState(false);
  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const searchValueTransaction = useRef("");
  const [allTransactions, setAllTransactions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [showRefundConfirmationAlert, setShowRefundConfirmationAlert] = useState(false)
  const [showAutotagConfirmationModal, setShowAutotagConfirmationModal] = useState(false)
  const [manualTagModal, setManualTagModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState()
  const [transactionSummary, setTransactionSummary] = useState({
    tagged: { count: 0, amount: 0 },
    untagged: { count: 0, amount: 0 },
    refunded: { count: 0, amount: 0 },
  });
  const [transactionDetailModal, setTransactionDetailModal] = useState(false);
  const [detailTransaction, setDetailTransaction] = useState(null);
  const [taggedTarget, setTaggedTarget] = useState({ tokens: [], allotments: [] });
  const [taggedTargetLoading, setTaggedTargetLoading] = useState(false);
  const [pendingDues, setPendingDues] = useState({ tokens: [], allotments: [] });
  const [pendingDuesLoading, setPendingDuesLoading] = useState(false);

  useEffect(() => {
    if (!transactionDetailModal || !detailTransaction) {
      setTaggedTarget({ tokens: [], allotments: [] });
      setPendingDues({ tokens: [], allotments: [] });
      return;
    }
    // Always look up what's already been tagged against this pay ID — a transaction can be
    // partially tagged (some money placed, some still untagged) across separate Manual Tag
    // calls, so "already tagged" and "still pending" are not mutually exclusive states.
    setTaggedTargetLoading(true);
    getTaggedTransactionTarget(detailTransaction.payid)
      .then(setTaggedTarget)
      .catch((err) => {
        console.log(err);
        setTaggedTarget({ tokens: [], allotments: [] });
      })
      .finally(() => setTaggedTargetLoading(false));

    if (!detailTransaction.tagged && !detailTransaction.refunded) {
      setPendingDuesLoading(true);
      getPendingDuesForLead(detailTransaction.leaddisplayid)
        .then(setPendingDues)
        .catch((err) => {
          console.log(err);
          setPendingDues({ tokens: [], allotments: [] });
        })
        .finally(() => setPendingDuesLoading(false));
    } else {
      setPendingDues({ tokens: [], allotments: [] });
    }
  }, [transactionDetailModal, detailTransaction]);
  const tagGridColumns = [
    loggedInUser?.roleId?.accessibleTabs?.["Payments"]?.["Untagged Transactions"]?.["Refund"]?.isAccessible && {
      field: "Actions",
      headerName: "",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params?.row?.refunded ? (
              <LeadStatusChip
                label={"Refunded"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
              ></LeadStatusChip>
            ) : params?.row?.tagged ? (
              <LeadStatusChip
                label={"Tagged"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
              ></LeadStatusChip>
            ) : (
              <ThreeDotsMenu
                style={{
                  "& .MuiSvgIcon-root": {
                    fontSize: "3rem !important",
                  },
                }}
                list={["Refund", "Auto-tag", "Manual Tag"]}
                selectedValue={(e) => {
                  if (e === "Refund") {
                    setShowRefundConfirmationAlert(true);
                    setSelectedTransaction(params.row);
                  } else if (e === "Auto-tag") {
                    setShowAutotagConfirmationModal(true)
                    setSelectedTransaction(params.row)
                  } else if (e === "Manual Tag") {
                    setSelectedTransaction(params.row);
                    setManualTagModal(true);
                  }
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Date",
      width: 300,
      renderCell: (params) => {
        return (
          <div>
            <span>
              {new Date(params?.row?.last_updated_at).toDateString()},{" "}
              {new Date(params?.row?.last_updated_at).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })}
            </span>
          </div>
        );
      },
    },
    {
      field: "age",
      headerName: "Age",
      width: 180,
      renderCell: (params) => {
        return (
          <div>
            <ReactTimeAgo
              date={new Date(params?.row?.last_updated_at)}
              locale="en-US"
            />
          </div>
        );
      },
    },
    {
      field: "leaddisplayid",
      headerName: "CUID",
      width: 180,
      renderCell: (params) => {
        return (
          < div >
            {
              'VJ' +
              params?.row?.leaddisplayid?.replace(
                params?.row?.leaddisplayid?.substring(8, 12),
                '-' + params?.row?.leaddisplayid?.substring(8, 12)
              )
            }
          </div >
        );
      },
    },
    {
      field: "leadName",
      headerName: "Lead Name",
      width: 220,
      renderCell: (params) => {
        return (
          <div>
            {
              params?.row?.leadname
            }
          </div>
        );
      },
    },
    {
      field: "payId",
      headerName: "Pay Id",
      width: 220,
      renderCell: (params) => {
        return <div>{params?.row?.payid}</div>;
      },
    },
    {
      field: "Amount",
      headerName: "Amount",
      width: 180,
      renderCell: (params) => {
        return <div>₹ {numberWithCommas(params?.row?.amount)}</div>;
      },
    },
    {
      field: "modeOfPayment",
      headerName: "Mode Of Payment",
      width: 200,
      renderCell: (params) => {
        return <div>{params?.row?.modeofpayment}</div>;
      },
    },
  ];


  useEffect(() => {
    dispatch(actions.activeMenu("transactions"));
    getTransactionPagination(
      0,
      searchValueTransaction.current,
      filterByTransaction,
      selectDates,
      false
    );
  }, []);

  useEffect(() => {
    setPageMaintain(0);
    setPageNumber(0);
    getTransactionPagination(
      0,
      searchValueTransaction.current,
      filterByTransaction,
      selectDates,
      false
    );
  }, [filterByTransaction, selectDates]);

  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getTransactionPagination(
      passPageNumber,
      searchValueTransaction.current,
      filterByTransaction,
      selectDates,
      true
    );
  }

  async function getTransactionPagination(
    pageNumber,
    searchValue,
    filterBy,
    selectDates,
    merge
  ) {
    if (loggedInUser?.roleId?.accessibleTabs?.["Payments"]
      ?.["Untagged Transactions"]?.isAccessible) {
      presentLoader();
      getAllTransactions(
        pageNumber * pageSize,
        pageNumber * pageSize + pageSize - 1,
        searchValue,
        filterBy,
        selectDates,
      )
        .then((getTransaction) => {
          setTotalCount(getTransaction?.count)
          if (merge) {
            setAllTransactions((pre) => [...pre, ...getTransaction?.data]);
          } else {
            setAllTransactions([...getTransaction?.data]);
            getTransactionSummary(searchValue, selectDates);
          }
          dismissLoader();
        })
        .catch((err) => {
          dismissLoader();
          if (err?.message === "Requested range not satisfiable") {
            infoTost("No more data.");
          } else if (err?.message) {
            errorTost(err?.message)
          } else {
            errorTost("Something went wrong! Try again");
          }
        });
    }
  }

  function getTransactionSummary(searchValue, selectDates) {
    getAllTransactionsSummary(searchValue, selectDates)
      .then((rows) => {
        const summary = (rows || []).reduce(
          (acc, row) => {
            const amt = Number(row?.amount) || 0;
            const bucket = row?.refunded
              ? acc.refunded
              : row?.tagged
              ? acc.tagged
              : acc.untagged;
            bucket.count += 1;
            bucket.amount += amt;
            return acc;
          },
          {
            tagged: { count: 0, amount: 0 },
            untagged: { count: 0, amount: 0 },
            refunded: { count: 0, amount: 0 },
          }
        );
        setTransactionSummary(summary);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleRefund = () => {
    presentLoader();
    const payload = {
      untaggedTransactionId: selectedTransaction?.id,
    };
    refundFromTransactionPayment(payload)
      .then((response) => {
        dismissLoader();
        setSelectedTransaction()
        setPageMaintain(0);
        setPageNumber(0);
        getTransactionPagination(
          0,
          searchValueTransaction?.current,
          filterByTransaction,
          selectDates,
          false
        );
        successTost("Transaction refunded successfully.");
      })
      .catch((err) => {
        dismissLoader();
        setSelectedTransaction()
        if (err?.response?.data?.message) {
          errorTost(err.response.data.message);
        } else {
          errorTost("Something went wrong ! please try again later.")
        }
      });
  };

  const handleAutotagTransaction = () => {
    presentLoader();
    const payload = {
      id: [selectedTransaction?.id],
    };
    autotagFromTransactionPayment(payload)
      .then((response) => {
        console.log('response: ', response);
        dismissLoader();
        setSelectedTransaction()
        setPageMaintain(0);
        setPageNumber(0);
        getTransactionPagination(
          0,
          searchValueTransaction?.current,
          filterByTransaction,
          selectDates,
          false
        );
        if (!response?.data?.success) {
          errorTost(response?.data?.message)
        } else {
          successTost("Transaction auto-tag successfully.");
        }
      })
      .catch((err) => {
        dismissLoader();
        setSelectedTransaction()
        if (err?.response?.data?.message) {
          errorTost(err.response.data.message);
        } else {
          errorTost("Something went wrong ! please try again later.")
        }
      });
  };

  const debouncedFetchSearchDataForTransaction = debounce((e) => {
    searchValueTransaction.current = e.target.value;
    setPageMaintain(0);
    setPageNumber(0);
    getTransactionPagination(
      0,
      searchValueTransaction?.current,
      filterByTransaction,
      selectDates,
      false
    );
  }, 500);
  // useEffect(
  //   () => {
  //     setView({id : 2, label : "Table View"})
  //   },
  //   [buttonName === "Bulk Refund Request"]
  // )

  function valuetext(value) {
    return `${value}°C`;
  }

  const scaleValues = (valueArray) => {
    return [scale(valueArray[0]), scale(valueArray[1])];
  };
  const scale = (value) => {
    if (value === undefined) {
      return undefined;
    }

    const previousMarkIndex = Math.floor(value / 25);
    const previousMark = all_prices[previousMarkIndex];
    const remainder = value % 50;
    if (remainder === 0) {
      return previousMark?.scaledValue;
    }
    const nextMark = all_prices[previousMarkIndex + 1];
    const increment = (nextMark?.scaledValue - previousMark?.scaledValue) / 25;
    return remainder * increment + previousMark?.scaledValue;
  };

  //!! SnapShort Added if transaction is being updated
  useEffect(() => {
    if (openTab === "Tokens") {
      let tokenTransaction = supabase
        .from(`TokenTransactions`)
        .on("UPDATE", (handleRecordUpdated) => {
          if (handleRecordUpdated.eventType === "UPDATE") {
            getPlans("", "", filterBy, checked, from, to, selectBulk);
          }
        })
        .subscribe((status) => { });
      return () => {
        if (tokenTransaction) {
          supabase.removeSubscription(tokenTransaction);
          tokenTransaction = null;
        }
      };
    }
    // if(details[itemCont]?.paymentid){
    //   let tokenTransaction = supabase
    //       .from(`TokenTransactions:paymentId=eq.${details[itemCont].paymentid}`)
    //       .on("UPDATE", (handleRecordUpdated) => {
    //         console.log(handleRecordUpdated);
    //         if (handleRecordUpdated.eventType === "UPDATE") {
    //           if(viewModal){
    //             getTokenTransaction(details[itemCont].paymentid);
    //             setViewModal(true);
    //           }
    //         }
    //       })
    //       .subscribe((status) => {
    //         console.log("status: ", status);
    //       });
    //       return () => {
    //         if (tokenTransaction) {
    //           supabase.removeSubscription(tokenTransaction);
    //           tokenTransaction = null;
    //         }
    //       };
    // }
  }, []);

  useEffect(() => {
    let all_filters = [];

    let all_cpId = [];
    let all_projectId = [];
    let all_salesRepresentativeId = [];
    let all_TokenId = [];
    let all_InventoryTypeId = [];
    let all_PaymentStatus = [];
    let all_AllotmentStatus = [];
    let jsonParse;

    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter === "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter === "Events") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter === "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter === "Tokens") {
        all_TokenId.push(jsonParse.value);
      } else if (jsonParse.filter === "InventoryType") {
        all_InventoryTypeId.push(jsonParse.value);
      } else if (jsonParse.filter === "PaymentStatus") {
        all_PaymentStatus.push(jsonParse.value);
      } else if (jsonParse.filter === "AllotmentStatus") {
        all_AllotmentStatus.push(jsonParse.value);
      }
    });

    if (all_cpId.length !== 0) {
      if (all_filters.indexOf("CP") === -1) {
        all_filters.push("CP");
      }
    }

    if (all_projectId.length !== 0) {
      if (all_filters.indexOf("Events") === -1) {
        all_filters.push("Events");
      }
    }

    if (all_salesRepresentativeId.length !== 0) {
      if (all_filters.indexOf("Sales Manager") === -1) {
        all_filters.push("Sales Manager");
      }
    }

    if (all_InventoryTypeId.length !== 0) {
      if (all_filters.indexOf("Inventory Type Name") === -1) {
        all_filters.push("Inventory Type Name");
      }
    }

    if (all_TokenId.length !== 0) {
      if (all_filters.indexOf("Token Type Name") === -1) {
        all_filters.push("Token Type Name");
      }
    }
    if (all_PaymentStatus.length !== 0) {
      if (all_filters.indexOf("Payment") === -1) {
        all_filters.push("Payment");
      }
    }
    if (all_AllotmentStatus.length !== 0) {
      if (all_filters.indexOf("Allotment Status") === -1) {
        all_filters.push("Allotment Status");
      }
    }

    if (projectSelected.length !== 0) {
      all_filters.push("Project");
    }
    //  if(from===''&&to===''&&all_filters.length == 0){
    //     all_filters.push("None");

    //   }
    if (from !== "" && to !== "") {
      all_filters.push("Price Range");
    }
    if (all_filters.length === 0) {
      setBtnName("None");
    } else {
      setBtnName(all_filters.join(" ,"));
    }
  }, [checked]);

  // **get token Transactions
  function getTokenTransaction(paymentId) {
    getTokenTransactions(paymentId)
      .then((resp) => {
        setTokenTransaction([...resp]);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function getAT_Timeline(aId) {
    getAllotmentTransactionsTimeline(aId)
      .then((resp) => {
        console.log("allotment transactions", resp);
        setAllotmentTransaction([...resp]);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  const handleToggle = (value, filter) => () => {
    const currentIndex = checked.indexOf(
      JSON.stringify({ value: value, filter: filter })
    );
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(JSON.stringify({ value: value, filter: filter }));
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  useEffect(() => {
    if (filter === "CP") {
      setFilterNames(cp);
    } else if (filter === "Events") {
      setFilterNames(events);
    } else if (filter === "Users") {
      setFilterNames(salesRepresentative);
    } else if (filter === "InventoryType") {
      setFilterNames(inventoryTypes);
    } else if (filter === "Tokens") {
      setFilterNames(tokenTypes);
    }
  }, [filter]);

  useEffect(() => {
    dispatch(actions.activeMenu("payments"));
    getSubfilters("None", 0);
  }, []);

  const handleChange = (event, newValue) => {
    let priceRanges = scaleValues(value);
    let fromRange = priceRanges[0];
    let toRange = priceRanges[1];
    let name = "Price Range";
    if (btnName.includes("Price Range") === false) {
      if (btnName.includes("None")) {
        setBtnName(name);
      } else {
        setBtnName((pre) => [pre, name]);
      }
    }
    setFrom(fromRange);
    setTo(toRange);
    setValue(newValue);
  };

  async function getSubfilters(value, filterId) {
    let CP_Items = [];
    let Events_Items = [];
    let Inventory_Items = [];
    let Token_types = [];

    if (value !== "priceRange") {
      setShowPriceRange(false);
    }
    if (value !== "Projects") {
      setShowProjectList(false);
    }
    if (value === "CP") {
      if (!cp[0]) {
        const { data } = await getFilterNames(value);

        data.map((item) => {
          CP_Items.push({
            id: item.cpId,
            name: item.billingName,
            filter: value,
          });
        });

        const sortedCp = orderBy(
          CP_Items,
          [(cp) => cp.name.toLowerCase()],
          ["asc"]
        );
        setCp(sortedCp);
      }
      setFilter(value);
    } else if (value === "Events") {
      if (!events[0]) {
        const { data } = await getFilterNames(value);

        data.map((item) => {
          Events_Items.push({
            id: item.eventId,
            name: item.title,
            filter: value,
          });
        });

        setEvents(Events_Items);
      }
      setFilter(value);
    } else if (value === "Users") {
      if (!salesRepresentative[0]) {
        const { data } = await getFilterNames(value);
        data.map((item) => {
          Events_Items.push({
            id: item.userId,
            name: item.name,
            filter: value,
          });
        });

        const sortedSales = orderBy(
          Events_Items,
          [(user) => user.name.toLowerCase()],
          ["asc"]
        );
        setSalesRepresentative(sortedSales);
      }
      setFilter(value);
    } else if (value === "priceRange") {
      setShowPriceRange(true);
      setFilter(value);
    } else if (value === "Tokens") {
      if (!tokenTypes[0]) {
        const { data } = await getFilterNames(value);

        data.map((item) => {
          Token_types.push({
            id: item.tokenId,
            name: item.name,
            filter: value,
          });
        });

        const sortedTokenTypes = orderBy(
          Token_types,
          [(type) => type.name.toLowerCase()],
          ["asc"]
        );
        setTokenTypes(sortedTokenTypes);
      }
      setFilter(value);
    } else if (value === "InventoryType") {
      if (!inventoryTypes[0]) {
        const { data } = await getFilterNames(value);

        data.map((item) => {
          Inventory_Items.push({
            id: item.inventoryTypeId,
            name: item.type,
            filter: value,
          });
        });

        const sortedTypes = orderBy(
          Inventory_Items,
          [(type) => type.name.toLowerCase()],
          ["asc"]
        );
        let obj = sortedTypes.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.name === value.name)
        );
        setInventoryTypes(obj);
      }
      setFilter(value);
    } else if (value === "PaymentStatus") {
      const data = [
        "pending",
        "partial",
        "active",
        "alloted",
        "refund initiated",
        "refund requested",
        "refund processed",
        "refund rejected",
        "expired",
        "adjusted",
      ].map((d, index) => ({
        name: d[0].toLocaleUpperCase() + d.slice(1),
        id: d,
        filter: value,
      }));
      setPaymentStatus(data);
      setFilter(value);
      setFilterNames(data);
    } else if (value === "AllotmentStatus") {
      const data = [
        "Payment Pending",
        "Cancellation Requested",
        "Change Requested",
        "Cancellation Pending",
        "Partial Payment Done",
        "Released",
        "Refund Processed",
        "Preselected",
        "Payment Complete",
        "On Hold",
        "Refund Initiated",
        "Cancelled",
        "Agreement Done",
      ].map((d, index) => ({
        name: d[0].toLocaleUpperCase() + d.slice(1),
        id: d,
        filter: value,
      }));
      setAllotmentStatus(data);
      setFilter(value);
      setFilterNames(data);
    } else if (value === "Projects") {
      setShowProjectList(true);
      if (!projectList[0]) {
        const data = await getProjectList();
        setProjectList(data);
      }
      setFilter(value);
    } else {
      setFilter("None");
      setCp([]);
      setSalesRepresentative([]);
      setProjectList([]);
      setProjectSelected([]);
      setAllotmentStatus([]);
      setPaymentStatus([]);
      setInventoryTypes([]);
      setTokenTypes([]);
      setEvents([]);
      setChecked([]);
      setFilterNames([]);
    }

    setFilterCheck(filterId);

    // if (response) {
    //     console.log('filterData', response)
    //     setFilterNames(response)
    // }
  }

  function numFormatter(num) {
    if (num > 999 && num < 1000000) {
      return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(0) + "M"; // convert to M for number from > 1 million
    } else if (num < 900) {
      return num; // if value < 1000, nothing to do
    }
  }

  const handleFilterClose = (isClear = false) => {
    setRange({ from: 0, to: 9 });
    setLoadingStatus(0);
    if (filterOpen) {
      isClear && setChecked([]);
      isClear && setFrom("");
      isClear && setTo("");
      isClear && setProjectStr({ p: [], w: [], f: [] });
      isClear && setValue([1, 200]);
      isClear && setProjectSelected([]);
      //getSubfilters("CP", 1);

      isClear && setFilterCheck("None");
      isClear && getSubfilters("None", 0);
      setFilterOpen(false);
      isClear && getPlans("", "", filterBy, [], "", "", selectBulk);
    } else {
      setFilterOpen(true);
    }
  };
  function filterPaymentBySort(e) {
    getPlans("", "", e, checked, from, to, selectBulk);
    setFilterBy(e);
  }
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    // boxShadow: 24,
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setPlanDetail({});
    setOpen(false);
    getPlans("", "", filterBy, checked, from, to, selectBulk);
  };

  const handleViewClose = () => {
    setViewModal(false);
  };
  const [leadObj, setLeadObj] = useState(null);
  let filterObj = [
    {
      id: 0,
      label: "None",
      value: "None",
    },
    {
      id: 1,
      label: "CP",
      value: "CP",
    },
    {
      id: 2,
      label: "Sales Manager",
      value: "Users",
    },

    // {
    //   id: 4,
    //   label: "Price Range",
    //   value: "priceRange",
    // },
    {
      id: 5,
      label: "Token Types",
      value: "Tokens",
    },
    {
      id: 6,
      label: "Inventory Type",
      value: "InventoryType",
    },
    {
      id: 7,
      label: "Events",
      value: "Events",
    },

    // {
    //   id: 9,
    //   label: "Allotment Status",
    //   value: "AllotmentStatus",
    // },
  ];

  if (openTab === "Tokens") {
    filterObj = [
      ...filterObj,
      {
        id: 8,
        label: "Payment Status",
        value: "PaymentStatus",
      },
    ];
  } else {
    filterObj = [
      ...filterObj,
      {
        id: 9,
        label: "Allotment Status",
        value: "AllotmentStatus",
      },
      {
        id: 3,
        label: "Project Names",
        value: "Projects",
      },
    ];
  }

  useEffect(() => {
    if (openTab === "Tokens") {
      setAll_prices([
        {
          value: 0,
          scaledValue: 10000,
          label: "10K",
        },
        {
          value: 20,
          scaledValue: 20000,
          label: "20K",
        },
        {
          value: 30,
          scaledValue: 30000,
          label: "30K",
        },
        {
          value: 50,
          scaledValue: 50000,
          label: "50K",
        },
        {
          value: 100,
          scaledValue: 100000,
          label: "1L",
        },
        {
          value: 150,
          scaledValue: 500000,
          label: "5L",
        },
      ]);
    } else {
      setAll_prices([
        {
          value: 0,
          scaledValue: 1000000,
          label: "10L",
        },
        {
          value: 25,
          scaledValue: 2500000,
          label: "25L",
        },
        {
          value: 50,
          scaledValue: 5000000,
          label: "50L",
        },
        {
          value: 75,
          scaledValue: 7500000,
          label: "75L",
        },
        {
          value: 100,
          scaledValue: 10000000,
          label: "1Cr",
        },
      ]);
    }
    getPlans("", "", filterBy, checked, from, to, selectBulk);
  }, [openTab]);

  useEffect(() => {
    if (filter === "CP") {
      setFilterNames(
        cp.filter((f) =>
          searchValue
            ? f?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "Users") {
      setFilterNames(
        salesRepresentative.filter((f) =>
          searchValue
            ? f?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "Projects") {
      if (searchValue !== "") {
        setProjectList(
          projectList.filter((f) =>
            searchValue
              ? f?.label?.toLowerCase()?.includes(searchValue?.toLowerCase())
              : true
          )
        );
      } else {
        const fetchEvents = async () => {
          const data = await getProjectList();
          setProjectList(data);
        };
        fetchEvents();
      }
    }
  }, [searchValue]);

  useEffect(() => {
    setRange({ from: 0, to: 9 });
    // console.warn({ range });
  }, [openTab]);
  const userGridColumns = [
    {
      field: "action",
      headerName: "",
      width: 30,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className={cssClasses.actionDiv}>
            {openTab === "Tokens" &&
              details[params.value]?.refundable &&
              selectBulk &&
              // ((details[params.value]?.status === "alloted" &&
              //   !details[params.value].adjusttokenamt) ||
              (details[params.value]?.status === "alloted" ||
                details[params.value]?.status === "active" ||
                details[params.value]?.status === "partial") && (
                <div>
                  <Checkbox
                    sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }}
                    style={{ fontSize: "1.4rem" }}
                    checked={
                      selectedRequestToInitiate?.filter(
                        (val) =>
                          val.leadid === params.row.leadid &&
                          val?.tokennumber === params.row.tokennumber &&
                          val?.selected
                      )?.length > 0
                    }
                    onChange={(e) => {
                      const payload = [...selectedRequestToInitiate];
                      setSelectedRequestToInitiate(payload);
                      if (e.target.checked) {
                        const val = { ...params.row };
                        val.selected = e.target.checked;
                        payload.push(val);
                        setSelectedRequestToInitiate(payload);
                      } else {
                        const index = selectedRequestToInitiate.findIndex(
                          (val) =>
                            val?.leadid === params?.row?.leadid &&
                            val.tokennumber === params.row.tokennumber
                        );
                        payload.splice(index, 1);
                        setSelectedRequestToInitiate(payload);
                      }
                      // setDetails((pre) => {
                      //   pre[params.value].selected = e.target.checked;
                      //   return { ...pre };
                      // });
                    }}
                  />
                </div>
              )}
            {openTab === "Tokens" &&
              selectBulk &&
              (details[params.value]?.status !== "alloted" ||
                details[params.value]?.status !== "partial" ||
                details[params.value]?.status !== "active") && (
                <div>
                  <Tooltip
                    title={
                      <h1 style={{ color: "lightblue" }}>
                        Non refundable token
                      </h1>
                    }
                    disableInteractive
                    style={{ fontSize: "24px" }}
                  >
                    <InfoOutlinedIcon
                      style={{
                        fontSize: "2rem",
                        // verticalAlign: "middle",
                        cursor: "pointer",
                        marginLeft: "1rem",
                      }}
                    />
                  </Tooltip>
                </div>
              )}
            {!selectBulk && (
              <div>
                {/* Condition remaining to add for preSelect */}
                <ThreeDotsMenu
                  style={{
                    "& .MuiSvgIcon-root": {
                      fontSize: "3rem !important",
                    },
                  }}
                  list={
                    (openTab === "Tokens"
                      ? details[params.value]?.subMenu
                      : details[params.value]?.subMenuAllotment) || []

                    // details[params.value]?.refundable &&
                    //   ((details[params.value]?.status === "alloted" &&
                    //     !details[params.value]?.adjusttokenamt) ||
                    //     details[params.value].status === "active")
                    //   ? ["View Details", "Token Refund Request"]
                    //   // "Assign New Token"
                    //   :  !details[params.value]?.ispreselect&&details[params.value]?.status === "active"?
                    //   ["View Details","Assign New Token"]
                    //   : ["View Details"]
                    // loggedInUser.roleId.level === 1&&
                    // details[params.value]?.allotmentstatus==='Cancelled'
                    // ?
                    // !details[params.value]?.ispreselect?
                    // ["View Details","Initiate Refund",'Alot Unit']
                    // :
                    //   ["View Details","Initiate Refund"]:
                    //   ["View Details"]
                  }
                  selectedValue={async (value) => {
                    setItemCount(params.value);
                    // setTokenTransaction([]);
                    setSelectedCard((prev) => ({
                      ...prev,
                      viewDetails: params.row,
                    }));
                    if (openTab === "Tokens") {
                      if (value === "View Details") {
                        setViewModal(true);
                        setSelectedCard((prev) => ({
                          ...prev,
                          viewDetails: params.row,
                        }));
                        getTokenTransaction(details[params.value].paymentid);
                      } else if (value === "Token Refund Request") {
                        setRefundTokenModal(true);
                        getSpecificEventsTokenRefundRequests(
                          details[params.value].paymentid
                        )
                          .then((resp) => {
                            let tokenObject = {
                              tokenName: details[params.value].tokenname,
                              amount: details[params.value].amount,
                              paymentId: details[params.value].paymentid,
                              TokenRefundRequests: resp.data,
                              type: details[params.value].unittype,
                              paidAmount: details[params.value].paidamount,
                            };
                            setRefundTokenData(tokenObject);
                            let obj = {
                              leadId: details[params.value].leadid,
                              leadname: details[params.value].leadname,
                            };
                            setLeadObj(obj);
                          })
                          .catch((err) => { });
                      } else if ("Assign New Token") {
                        setAssignNewTokenModal(true);
                        getSpecificEventsTokenRefundRequests(
                          details[params.value].paymentid
                        )
                          .then((resp) => {
                            let tokenObject = {
                              ...details[params.value],
                              tokenName: details[params.value].tokenname,
                              amount: details[params.value].amount,
                              paymentId: details[params.value].paymentid,
                              TokenRefundRequests: resp.data,
                            };
                            setOldTokenData(tokenObject);
                          })
                          .catch((err) => { });
                        setOldTokenData(details[params.value]);
                        let obj = {
                          leadId: details[params.value]?.leadid,
                          leadname: details[params.value]?.leadname,
                          leadcontactnumber:
                            details[params.value]?.leadcontactnumber,
                          leademail: details[params.value]?.leademail,
                        };
                        setLeadObj(obj);
                      }
                    } else if (openTab === "Allotments") {
                      getAT_Timeline(details[params.value].allotmentpaymentid);
                      if (value === "View Details") {
                        setSelectedCard((prev) => ({
                          ...prev,
                          viewDetails: params.row,
                        }));
                        setViewModal(true);
                      } else if (value === "Initiate Refund") {
                        let obj = {
                          leadId: details[params.value]?.leadid,
                          leadname: details[params.value]?.leadname,
                          leadcontactnumber:
                            details[params.value]?.leadcontactnumber,
                          leadDetails: {
                            contactNumber:
                              details[params.value]?.leadcontactnumber,
                            leadEmail: details[params.value]?.leademail,
                          },
                          leademail: details[params.value]?.leademail,
                          leaddisplayid: details[params.value]?.leaddisplayid,
                        };
                        let allotmentObject = {
                          ...details[params.value],
                          tokenName: details[params.value].tokenname,
                          amount: details[params.value].amount,
                          paymentId: details[params.value].paymentid,
                        };
                        setOldAllotmentData(allotmentObject);
                        setLeadObj(obj);
                        setOpenAlertBoxForCancellation(true);
                      } else if (value === "Alot Unit") {
                        let obj = {
                          leadId: details[params.value]?.leadid,
                          leadname: details[params.value]?.leadname,
                          leadcontactnumber:
                            details[params.value]?.leadcontactnumber,
                          leadDetails: {
                            contactNumber:
                              details[params.value]?.leadcontactnumber,
                            leadEmail: details[params.value]?.leademail,
                          },
                          leademail: details[params.value]?.leademail,
                          leaddisplayid: details[params.value]?.leaddisplayid,
                        };
                        let allotmentObject = {
                          ...details[params.value],
                          tokenName: details[params.value].tokenname,
                          amount: details[params.value].amount,
                          paymentId: details[params.value].paymentid,
                        };
                        setOldAllotmentData(allotmentObject);
                        setLeadObj(obj);
                        // setAlotUnitModal(true);
                        setAlotExistingUnitModal(true);
                        // ! vedashree changes for pbc event preselect rebooking
                        sessionStorage.setItem('isPaymentTab', true)
                      }
                    }
                  }}
                />
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "uniqueLeadId",
      headerName: "Lead Name",
      flex: 1,
      minWidth: 270,
      sortable: false,
      renderCell: (params) => {
        let el = { leaddisplayid: params.value };
        return (
          <div style={{ paddingBottom: "0.5rem", paddingTop: "0.5rem" }}>
            <div style={{ whiteSpace: "normal", lineBreak: "anywhere" }}>
              {params.row.leadName}
            </div>
            <div
              style={{
                fontSize: "1.2rem",
                opacity: "0.7",
              }}
            >
              {"VJ" +
                el?.leaddisplayid?.replace(
                  el?.leaddisplayid?.substring(8, 12),
                  "-" + el?.leaddisplayid?.substring(8, 12)
                )}
            </div>
          </div>
        );
      },
    },
    {
      field: "transactionid",
      headerName: "TransactionID",
      flex: 1,
      minWidth: 180,
      sortable: false,
      hide: openTab === "Tokens" ? true : false,
      renderCell: (params) => {
        return `${params.value}`;
      },
    },
    {
      field: "projectName",
      headerName: "Event Name",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div style={{ whiteSpace: "normal", lineBreak: "anywhere" }}>
            {params?.row?.projectName}
          </div>
        );
      },
    },
    {
      field: openTab === "Tokens" ? "paidamount" : "amount",
      headerName: "Amount Paid",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return `₹ ${params.value.toLocaleString()}`;
      },
    },
    {
      field: "tokenNumber",
      headerName: "Token Number",
      flex: 1,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            {params.row.tokenNumber && <div> VJ{params.row.tokenNumber}</div>}
            <div
              style={{
                fontSize: "1.2rem",
                opacity: "0.8",
              }}
            >
              {params.row.tokenname}
            </div>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: openTab === "Tokens" ? "Status" : "Status",
      // flex: 1,
      minWidth: 250,
      sortable: false,
      renderCell: (params) => {
        // ??For linked Token
        if (
          openTab === "Tokens" &&
          params?.row?.linkedtokenid !== null &&
          params.value !== "expired" && params.value === "active"
        ) {
          return (
            <LeadStatusChip
              label={"Upgraded"}
              style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else {
          if (params.value === "complete") {
            return (
              <LeadStatusChip
                label={"Complete"}
                style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "pending") {
            return (
              <LeadStatusChip
                label={"Pending"}
                style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "refund rejected") {
            return (
              <LeadStatusChip
                label={"Refund Rejected"}
                style={{ color: "#FF4405", backgroundColor: "#FFE6D5" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "refund requested") {
            return (
              <LeadStatusChip
                label={"Refund requested"}
                style={{ color: "#C11574", backgroundColor: "#FDF2FA" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "alloted") {
            return (
              <LeadStatusChip
                label={"Alloted"}
                style={{ color: "#C01048", backgroundColor: "#FFF1F3" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "expired") {
            return (
              <LeadStatusChip
                label={"Expired"}
                style={{ color: "#000000", backgroundColor: "#ececec" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "partial") {
            return (
              <LeadStatusChip
                label={"Partial"}
                style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "Released") {
            return (
              <LeadStatusChip
                label={"Released"}
                style={{
                  color: "rgb(180, 35, 24)",
                  backgroundColor: "rgb(254, 243, 242)",
                }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "Partial Payment Done") {
            return (
              <LeadStatusChip
                label={"Partial Payment Done"}
                style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (
            params.value === "Cancelled" ||
            params.value === "cancelled"
          ) {
            return (
              <div>
                <LeadStatusChip
                  label={"Cancelled"}
                  style={{ color: "#C01048", backgroundColor: "#FFF1F3" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
                {params.row.paymenttransferred && (
                  <LeadStatusChip
                    label={"Payment Transferred"}
                    style={{ color: "#C01048", backgroundColor: "#FFF1F3" }}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  />
                )}
              </div>
            );
          } else if (params.value === "On Hold") {
            return (
              <LeadStatusChip
                label={"On Hold"}
                style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "Cancellation Pending") {
            return (
              <LeadStatusChip
                label={"Cancellation Pending"}
                style={{ color: "#FF4405", backgroundColor: "#FFE6D5" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "Payment Pending") {
            return (
              <LeadStatusChip
                label={"Payment Pending"}
                style={{ color: "#C11574", backgroundColor: "#FDF2FA" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else if (params.value === "Cancellation Requested") {
            return (
              <LeadStatusChip
                label={"Cancellation Requested"}
                style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          } else {
            return (
              <LeadStatusChip
                label={params.value}
                style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            );
          }
        }
      },
    },
    {
      field: "ModeOfPayment",
      headerName: "Mode Of Payment",
      flex: 1,
      minWidth: 180,
      sortable: false,
      hide: openTab === "Tokens" ? true : false,
      renderCell: (params) => {
        return `${params.value}`;
      },
    },
  ];
  const userGridColumnsAllotments = [
    {
      field: "action",
      headerName: "",
      width: 30,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className={cssClasses.actionDiv}>
            {openTab === "Tokens" &&
              details[params.value]?.refundable &&
              selectBulk &&
              // ((details[params.value]?.status === "alloted" &&
              //   !details[params.value].adjusttokenamt) ||
              (details[params.value]?.status === "alloted" ||
                details[params.value]?.status === "partial" ||
                details[params.value]?.status === "active") && (
                <div>
                  <Checkbox
                    sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }}
                    style={{ fontSize: "1.4rem" }}
                    checked={details[params.value].selected}
                    onChange={(e) => {
                      setDetails((pre) => {
                        pre[params.value].selected = e.target.checked;
                        return { ...pre };
                      });
                    }}
                  />
                </div>
              )}
            {openTab === "Tokens" &&
              selectBulk &&
              (details[params.value]?.status !== "alloted" ||
                details[params.value]?.status !== "active") && (
                <div>
                  <Tooltip
                    title={
                      <h1 style={{ color: "lightblue" }}>
                        Non refundable token
                      </h1>
                    }
                    disableInteractive
                    style={{ fontSize: "24px" }}
                  >
                    <InfoOutlinedIcon
                      style={{
                        fontSize: "2rem",
                        // verticalAlign: "middle",
                        cursor: "pointer",
                        marginLeft: "1rem",
                      }}
                    />
                  </Tooltip>
                </div>
              )}
            {!selectBulk && (
              <Box>
                {/* Condition remaining to add for preSelect */}
                <ThreeDotsMenu
                  style={{
                    "& .MuiSvgIcon-root": {
                      fontSize: "3rem !important",
                    },
                  }}
                  list={
                    (openTab === "Tokens"
                      ? details && details[params.value]?.subMenu
                      : params.row?.subMenuAllotment) || []
                  }
                  selectedValue={async (value) => {
                    setSelectedCard((prev) => ({
                      ...prev,
                      viewDetails: params.row,
                    }));
                    setItemCount(params.value);
                    // setTokenTransaction([]);
                    if (openTab === "Tokens") {
                      if (value === "View Details") {
                        setViewModal(true);
                        setSelectedCard((prev) => ({
                          ...prev,
                          viewDetails: params.row,
                        }));
                        getTokenTransaction(details[params.value].paymentid);
                      } else if (value === "Token Refund Request") {
                        setRefundTokenModal(true);

                        getSpecificEventsTokenRefundRequests(
                          details[params.value].paymentid
                        )
                          .then((resp) => {
                            let tokenObject = {
                              tokenName: details[params.value].tokenname,
                              amount: details[params.value].amount,
                              paymentId: details[params.value].paymentid,
                              TokenRefundRequests: resp.data,
                              type: details[params.value].unittype,
                              paidAmount: details[params.value].paidamount,
                            };
                            setRefundTokenData(tokenObject);
                            let obj = {
                              leadId: details[params.value].leadid,
                              leadname: details[params.value].leadname,
                            };
                            setLeadObj(obj);
                          })
                          .catch((err) => { });
                      } else if ("Assign New Token") {
                        setAssignNewTokenModal(true);
                        getSpecificEventsTokenRefundRequests(
                          details[params.value].paymentid
                        )
                          .then((resp) => {
                            let tokenObject = {
                              ...details[params.value],
                              tokenName: details[params.value].tokenname,
                              amount: details[params.value].amount,
                              paymentId: details[params.value].paymentid,
                              TokenRefundRequests: resp.data,
                            };
                            setOldTokenData(tokenObject);
                          })
                          .catch((err) => { });
                        setOldTokenData(details[params.value]);
                        let obj = {
                          leadId: details[params.value]?.leadid,
                          leadname: details[params.value]?.leadname,
                          leadcontactnumber:
                            details[params.value]?.leadcontactnumber,
                          leademail: details[params.value]?.leademail,
                        };
                        setLeadObj(obj);
                      }
                    } else if (openTab === "Allotments") {
                      getAT_Timeline(details[params.value].allotmentpaymentid);

                      if (value === "View Details") {
                        setViewModal(true);
                        getAT_Timeline(
                          details[params.value].allotmentpaymentid
                        );
                        setSelectedCard((prev) => ({
                          ...prev,
                          viewDetails: params.row,
                        }));
                      } else if (value === "Initiate Refund") {
                        let obj = {
                          leadId: details[params.value]?.leadid,
                          leadname: details[params.value]?.leadname,
                          leadcontactnumber:
                            details[params.value]?.leadcontactnumber,
                          leadDetails: {
                            contactNumber:
                              details[params.value]?.leadcontactnumber,
                            leadEmail: details[params.value]?.leademail,
                          },
                          leademail: details[params.value]?.leademail,
                          leaddisplayid: details[params.value]?.leaddisplayid,
                        };
                        let allotmentObject = {
                          ...details[params.value],
                          tokenName: details[params.value].tokenname,
                          amount: details[params.value].amount,
                          paymentId: details[params.value].paymentid,
                        };
                        setOldAllotmentData(allotmentObject);
                        setLeadObj(obj);
                        setOpenAlertBoxForCancellation(true);
                      } else if (value === "Alot Unit") {
                        let obj = {
                          leadId: details[params.value]?.leadid,
                          leadname: details[params.value]?.leadname,
                          leadcontactnumber:
                            details[params.value]?.leadcontactnumber,
                          leadDetails: {
                            contactNumber:
                              details[params.value]?.leadcontactnumber,
                            leadEmail: details[params.value]?.leademail,
                          },
                          leademail: details[params.value]?.leademail,
                          leaddisplayid: details[params.value]?.leaddisplayid,
                        };
                        let allotmentObject = {
                          ...details[params.value],
                          tokenName: details[params.value].tokenname,
                          amount: details[params.value].amount,
                          paymentId: details[params.value].paymentid,
                        };
                        setOldAllotmentData(allotmentObject);
                        setLeadObj(obj);
                        // setAlotUnitModal(true);
                        setAlotExistingUnitModal(true);
                        // ! vedashree changes for pbc event preselect rebooking
                        sessionStorage.setItem('isPaymentTab', true)
                      }
                    }
                  }}
                />
              </Box>
            )}
          </div>
        );
      },
    },
    {
      field: "uniqueLeadId",
      headerName: "Lead Name",
      flex: 1,
      minWidth: 300,
      sortable: false,
      renderCell: (params) => {
        let el = { leaddisplayid: params.value };
        return (
          <div style={{ paddingBottom: "0.5rem", paddingTop: "0.5rem" }}>
            <div>{params.row.leadName}</div>
            <Box
              display={"flex"}
              gap={1}
              sx={{
                "& *": {
                  fontSize: "1.3rem!important",
                  opacity: "0.8",
                },
              }}
            >
              <div>
                {"VJ" +
                  el?.leaddisplayid?.replace(
                    el?.leaddisplayid?.substring(8, 12),
                    "-" + el?.leaddisplayid?.substring(8, 12)
                  )}{" "}
                |
              </div>
              <div>
                {params.row.unitno} | {params.row.floorno}
              </div>
            </Box>
          </div>
        );
      },
    },
    {
      field: "projectName",
      headerName: "Project Name",
      flex: 1,
      minWidth: 180,
      sortable: false,
    },
    {
      field: openTab === "Tokens" ? "paidamount" : "amount",
      headerName: "Amount Paid",
      // flex: 1,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => {
        // console.log({ params });
        return `₹ ${params?.row?.paidamount?.toLocaleString()}`;
      },
    },
    {
      field: "tokenNumber",
      headerName: "Token Number",
      flex: 1,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            {params.row.tokenNumber && <div> VJ{params.row.tokenNumber}</div>}
            <div>{params.row.tokenname}</div>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: openTab === "Tokens" ? "Status" : "Status",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        if (params.value === "complete") {
          return (
            <LeadStatusChip
              label={"Complete"}
              style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "pending") {
          return (
            <LeadStatusChip
              label={"Pending"}
              style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "refund rejected") {
          return (
            <LeadStatusChip
              label={"Refund Rejected"}
              style={{ color: "#FF4405", backgroundColor: "#FFE6D5" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "refund requested") {
          return (
            <LeadStatusChip
              label={"Refund requested"}
              style={{ color: "#C11574", backgroundColor: "#FDF2FA" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "alloted") {
          return (
            <LeadStatusChip
              label={"Alloted"}
              style={{ color: "#C01048", backgroundColor: "#FFF1F3" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "expired") {
          return (
            <LeadStatusChip
              label={"Expired"}
              style={{ color: "#000000", backgroundColor: "#ececec" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "partial") {
          return (
            <LeadStatusChip
              label={"Partial"}
              style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "Released") {
          return (
            <LeadStatusChip
              label={"Released"}
              style={{
                color: "rgb(180, 35, 24)",
                backgroundColor: "rgb(254, 243, 242)",
              }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "Partial Payment Done") {
          return (
            <LeadStatusChip
              label={"Partial Payment Done"}
              style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (
          params.value === "Cancelled" ||
          params.value === "cancelled"
        ) {
          return (
            <div
              style={{
                display: "flex",
                gap: "1rem",
                flexDirection: "column",
              }}
            >
              <LeadStatusChip
                label={"Cancelled"}
                style={{ color: "#C01048", backgroundColor: "#FFF1F3" }}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
              {params.row.paymenttransferred && (
                <LeadStatusChip
                  label={"Payment Transferred"}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                />
              )}
            </div>
          );
        } else if (params.value === "On Hold") {
          return (
            <LeadStatusChip
              label={"On Hold"}
              style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "Cancellation Pending") {
          return (
            <LeadStatusChip
              label={"Cancellation Pending"}
              style={{ color: "#FF4405", backgroundColor: "#FFE6D5" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "Payment Pending") {
          return (
            <LeadStatusChip
              label={"Payment Pending"}
              style={{ color: "#C11574", backgroundColor: "#FDF2FA" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else if (params.value === "Cancellation Requested") {
          return (
            <LeadStatusChip
              label={"Cancellation Requested"}
              style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        } else {
          return (
            <LeadStatusChip
              label={params.value}
              style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          );
        }
      },
    },
  ];


const downloadAllotmentExcel = (data, fileName = "Allotment.xlsx") => {
  try {
    const {
      allotmentTransaction = [],
      leadName = "",
      uniqueLeadId = "",
      projectName = "",
      wingName = "",
      unitType = "",
      wingUnit = ""
    } = data;

    let excelRows = [];
    let paidTotal = 0;
    let refundTotal = 0;
    const payIdMap = {}; // To accumulate total paid amount and track refund details by Pay ID
    const processedPayIds = new Set(); // To track already processed Pay IDs

    allotmentTransaction.forEach((t) => {
      // Skip pending status
      if (t.status?.toLowerCase() === "pending") return;

      const paidAmount = Number(t.amount || 0);
      paidTotal += paidAmount;

      const payId = t.payId || "";
      let refundAmount = 0;
      let refundId = "";
      let refundDate = "";
      let UTR = "";

      // Ensure payIdMap[payId] is initialized before modifying its properties
      if (!payIdMap[payId]) {
        payIdMap[payId] = { paidAmount: 0, refundAmount: 0, refundId: "", refundDate: "", UTR: "" };
      }

      // Handle refund details (if present)
      const refundEntity = t.transactionDetails?.refundPayload?.payload?.refund?.entity;

      if (refundEntity) {
        refundId = refundEntity.id || "";
        refundAmount = refundEntity.amount ? refundEntity.amount / 100 : 0;

        // Only add the refund amount to total if it's the first refund for the Pay ID
        if (!payIdMap[payId].refundAmount) {
          payIdMap[payId].refundAmount = refundAmount;
          payIdMap[payId].refundId = refundId;
          payIdMap[payId].refundDate = refundEntity.created_at
            ? new Date(refundEntity.created_at * 1000).toLocaleString("en-IN")
            : "";
          
          // Add to refundTotal only once for each Pay ID
          refundTotal += refundAmount;
        }
        // The ARN/RRN may live on the refund entity OR on the payment entity
        // within the same refundPayload. Razorpay frequently leaves the refund
        // entity's acquirer_data empty (arn/rrn null) while the payment entity
        // carries the real reference, so fall back through both before giving up.
        const paymentAcquirer =
          t.transactionDetails?.refundPayload?.payload?.payment?.entity
            ?.acquirer_data;
        UTR =
          refundEntity.acquirer_data?.arn ||
          refundEntity.acquirer_data?.rrn ||
          paymentAcquirer?.arn ||
          paymentAcquirer?.rrn ||
          "";
      } else {
        // If no refund, take the UTR from the payment details.
        // The UTR/bank reference lives in a different field depending on the
        // Razorpay payment method, so fall back through each possibility.
        const paymentPayload = t.transactionDetails?.paymentPayload?.payload;
        // console.log("================paymentPayload", paymentPayload);
        const acquirerData = paymentPayload?.payment?.entity?.acquirer_data;
        UTR =
          acquirerData?.bank_transaction_id || // netbanking
          acquirerData?.rrn ||                 // upi
          acquirerData?.transaction_id ||      // wallet / paylater
          paymentPayload?.bank_transfer?.entity?.bank_reference || // bank_transfer (virtual account NEFT/IMPS/RTGS)
          "";
      }

      // Update payIdMap for the paidAmount
      payIdMap[payId].paidAmount += paidAmount;

      // If Pay ID already processed, skip adding this row again
      if (!processedPayIds.has(payId)) {
        excelRows.push({
          CUID: uniqueLeadId,
          Lead: leadName,
          Project: projectName,
          Wing: wingName,
          Unit: wingUnit,
          "Unit Type": unitType,
          "Pay ID": payId,
          "Paid amount": paidAmount ? paidAmount.toLocaleString("en-IN") : "",
          "Payment Date": new Date(t.created_at).toLocaleString("en-IN"),
          "Refund ID": refundId,
          "Refund amount": refundAmount ? refundAmount.toLocaleString("en-IN") : "",
          "Refund Date": payIdMap[payId].refundDate,
          UTR: UTR || "",
          Destination: t.modeOfPayment || "",
        });
        processedPayIds.add(payId); // Mark this Pay ID as processed
      }
    });

    // Now, update the rows with combined amounts for the same Pay ID
    Object.keys(payIdMap).forEach((payId) => {
      const totalPaid = payIdMap[payId].paidAmount;
      const totalRefund = payIdMap[payId].refundAmount;  // Use the individual refund value

      // Find the first occurrence of the same Pay ID in the rows and update it
      const row = excelRows.find((r) => r["Pay ID"] === payId);
      if (row) {
        row["Paid amount"] = totalPaid.toLocaleString("en-IN");
        // Keep the first refund value for the specific Pay ID
        row["Refund amount"] = totalRefund.toLocaleString("en-IN");
        row["Refund ID"] = payIdMap[payId].refundId; // Use the stored Refund ID
      }
    });

    // Add the TOTAL row
    excelRows.push({
      CUID: "",
      Lead: "",
      Project: "",
      Wing: "",
      Unit: "",
      "Unit Type": "",
      "Pay ID": "Paid TOTAL",
      "Paid amount": paidTotal.toLocaleString("en-IN"),
      "Refund ID": "Refund TOTAL",
      "Refund amount": refundTotal.toLocaleString("en-IN"), // Correctly calculate the Refund Total
      "Refund Date": "",
      UTR: "",
      Destination: "",
    });

    // EXPORT EXCEL
    const ws = XLSX.utils.json_to_sheet(excelRows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Allotments");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Ensure proper blob and URL creation for the download
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a download link and trigger the download
    const url = URL.createObjectURL(blob);  // Create the object URL for the Blob
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;

    // Append the link to the DOM and click to start download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);  // Remove the link after triggering download

    // Revoke the URL object to release resources
    URL.revokeObjectURL(url);
  } catch (err) {
    console.log("Error generating Excel:", err);
  }
};




  const timeLine = (
    openTab == "Tokens" ? tokenTransactions : allotmentTransaction
  ).map((timelineItem, timelineIndex) => {
    return (
      <Timeline
        position="right"
        sx={[
          {
            padding: "0rem !important",
            [`& .MuiTimeline-root `]: {
              padding: "0rem !important",
            },

            "& . MuiTypography-root": {
              padding: "19px 16px !important",
            },
            [`& .MuiTimelineItem-root:before`]: {
              flex: "0rem !important",
              padding: "0rem !important",
              "-webkitFlex": "none !important",
              //  content:'none '
            },
          },
        ]}
      >
        <TimelineItem
          key={`TimelineItem_${timelineIndex}`}
          color={timelineIndex === 0 ? `primary` : "grey"}
        >
          <TimelineSeparator>
            <TimelineDot sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }}>
              {timelineItem.isCompleted ? (
                <DoneIcon />
              ) : (
                <DoneIcon
                  className={
                    timelineIndex === 0 ? cssClasses.active : cssClasses.all
                  }
                />
              )}
            </TimelineDot>
            {timelineIndex !==
              (openTab == "Tokens" ? tokenTransactions : allotmentTransactions)
                .length -
              1 && (
                <TimelineConnector
                  sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }}
                />
              )}
          </TimelineSeparator>
          <TimelineContent>
            <Typography
              // fontFamily={"Roboto-Regular"}
              //  color={timelineIndex===0 ? `primary` : "#667085"}
              fontSize={"1.4rem"}
              style={{
                paddingTop: "0rem",
                textDecoration: timelineItem.isCompleted
                  ? "line-through"
                  : "none",
              }}
            >
              <div
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#000000",
                  lineHeight: "2rem",
                  verticalAlign: "middle",
                  marginRight: "0.5rem",
                }}
              >
                Transaction {timelineItem.status}
                {/* {timelineItem.status} */}
              </div>
              <div
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#475467",
                  lineHeight: "1.8rem",
                  verticalAlign: "middle",
                  marginRight: "0.5rem",
                }}
              >
                ₹{numberWithCommas(timelineItem.amount)}
              </div>
              <div
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#475467",
                  lineHeight: "1.8rem",
                  verticalAlign: "middle",
                  marginRight: "0.5rem",
                }}
              >
                {new Date(timelineItem.created_at).toDateString()},{" "}
                {new Date(timelineItem.created_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
              <div
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#475467",
                  lineHeight: "1.8rem",
                  verticalAlign: "middle",
                  marginRight: "0.5rem",
                }}
              >
                {timelineItem.payId}
              </div>

              {timelineItem.transactionDetails?.refundPayload && (((timelineItem.transactionDetails?.refundPayload?.payload?.refund?.entity?.amount) / 100) === (timelineItem.amount)) && <>
                <div
                  style={{
                    fontSize: "1.4rem",
                    fontFamily: "Inter-Medium",
                    color: "#475467",
                    lineHeight: "1.8rem",
                    verticalAlign: "middle",
                    marginRight: "0.5rem",
                  }}
                >
                  Refund Id:{timelineItem.transactionDetails?.refundPayload?.payload?.refund?.entity?.id}
                </div>
                <div
                  style={{
                    fontSize: "1.4rem",
                    fontFamily: "Inter-Medium",
                    color: "#475467",
                    lineHeight: "1.8rem",
                    verticalAlign: "middle",
                    marginRight: "0.5rem",
                  }}
                >
                  Issued on Date: {new Date((timelineItem.transactionDetails?.refundPayload?.payload?.refund?.entity?.created_at * 1000)).toDateString()},{" "}
                  {new Date(timelineItem.transactionDetails?.refundPayload?.payload?.refund?.entity?.created_at).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>
                <div
                  style={{
                    fontSize: "1.4rem",
                    fontFamily: "Inter-Medium",
                    color: "#475467",
                    lineHeight: "1.8rem",
                    verticalAlign: "middle",
                    marginRight: "0.5rem",
                  }}
                >
                  Amount:₹{numberWithCommas((timelineItem.transactionDetails?.refundPayload?.payload?.refund?.entity?.amount) / 100)}
                </div>
                <div
                  style={{
                    fontSize: "1.4rem",
                    fontFamily: "Inter-Medium",
                    color: "#475467",
                    lineHeight: "1.8rem",
                    verticalAlign: "middle",
                    marginRight: "0.5rem",
                  }}
                >
                  ARN/RRN:{timelineItem.transactionDetails?.refundPayload?.payload?.refund?.entity?.acquirer_data?.arn || timelineItem.transactionDetails?.refundPayload?.payload?.refund?.entity?.acquirer_data?.rrn || timelineItem.transactionDetails?.refundPayload?.payload?.payment?.entity?.acquirer_data?.arn || timelineItem.transactionDetails?.refundPayload?.payload?.payment?.entity?.acquirer_data?.rrn || "-"}
                </div>
              </>}

              {/* <InfoOutlinedIcon
                style={{
                  fontSize: "2rem",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (
                    timelineItem?.Reason === "" ||
                    timelineItem?.Reason === null
                  ) {
                    errorTost("No Information available");
                  } else {
                    setConfirmationAlertModal(true);
                    setReasonMessage(timelineItem?.Reason);
                  }
                }}
              ></InfoOutlinedIcon> */}
            </Typography>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    );
  });

  async function getPaymentsForDatagrid(nextRange = { from: 0, to: 9 }) {
    let filterTab = mainTabs.filter((e) => e.isSelected === true);

    if (filterTab[0].value === "Allotments") {
      let items = await getPlanWithPaginationForAllotment(
        "",
        "",
        filterBy,
        checked,
        from,
        to,
        selectBulk,
        nextRange,
        false
      );
      return items;
    } else if (filterTab[0].value === "Tokens") {
      let items = await getPlanWithPaginationForToken(
        "",
        "",
        filterBy,
        checked,
        from,
        to,
        selectBulk,
        nextRange,
        false
      );
      return items;
    }
  }

  async function getPlans(
    benefitPlanId,
    planName,
    filterBy,
    checked,
    from,
    to,
    selectBulk
  ) {
    setDetails([]);
    setPlans([]);
    setAllotmentTransactions([]);
    presentLoader();
    let tokenResponse
    let allotmentResponse
    let filterTab = mainTabs.filter((e) => e?.isSelected === true);
    if (filterTab[0].value !== "Allotments") {
      tokenResponse = await getPayments(
        benefitPlanId,
        planName,
        checked,
        search,
        filterBy,
        from,
        to,
        selectBulk
      );
    } else {
      allotmentResponse = await getAllotmentTransactions(
        benefitPlanId,
        planName,
        checked,
        search,
        filterBy,
        "",
        "",
        undefined,
        projectStr
      );
    }
    dismissLoader();
    const items = [];
    let count = 0;


    if (filterTab[0].value === "Allotments") {
      setAllotmentCount(allotmentResponse.count);
      allotmentResponse.data.map((d, i) => {
        items.push({
          id: count,
          leadName: d?.leadname,
          uniqueLeadId: d?.leaddisplayid,
          projectName: d?.projectname ? d?.projectname : d?.mergedproject,
          transactionId: d?.transactionid,
          amount: d?.amount,
          status: d?.allotmentstatus,
          allotmentstatus: d?.status,
          ModeOfPayment: "",
          // ModeOfPayment: d?.paymentmethod.includes("Virtual acc")
          //   ? "Virtual Account"
          //   : d?.paymentmethod,
          // paymentMethod: d?.paymentmethod.includes("Virtual acc")
          //   ? "Virtual Account"
          //   : d?.paymentmethod,
          tokenNumber: d?.tokennumber,
          action: count,
          wingName: d?.displaywingname ? d?.displaywingname : d?.wingname ? d?.wingname : d?.mergedwing,
          subMenuAllotment: [],
          wingUnit: d?.unitno
            ? d?.unitno
            : d.unit1no.toString() + "-" + d.unit2no.toString(),
          ...d,
        });
        count++;
      });
      items.forEach((el) => {
        if (el?.allotmentstatus === "Cancelled") {
          el.subMenuAllotment.push("View Details");
          if (loggedInUser.roleId.level === 1 && !el?.paymenttransferred && !el?.cancelledinfarvision) {
            el.subMenuAllotment.push("Initiate Refund");
          }
          // !el?.ispreselect
          // ! vedashree changes ==> removing el.pricingtype !== "preselect" condition as re-allotment is allowed for preselect from PBC event
          // if (el.pricingtype !== "preselect" && !el?.paymenttransferred) {
          if (!el?.paymenttransferred) {
            el.subMenuAllotment.push("Alot Unit");
          }
        } else {
          el.subMenuAllotment.push("View Details");
        }
      });
      setDetails([...items]);
      console.log("allotments-Data" , items)
      setAllotmentTransactions([...items]);
      setOpenTab(filterTab[0].value);
      return;
    } else if (filterTab[0].value === "Tokens") {
      setPaymentCount(tokenResponse.count);
      tokenResponse.data.map((d, i) => {
        items.push({
          id: count,
          leadName: d?.leadname,
          uniqueLeadId: d?.leaddisplayid,
          projectName: d?.eventname,
          transactionId: d?.transactionid,
          amount: d?.amount,
          status: d?.status,
          tokenNumber: d?.tokennumber,
          action: count,
          selected: d?.refundable ? false : null,
          subMenu: [],
          ...d,
        });
        count++;
      });
      // !!SubMenu
      items.forEach((el) => {
        if (
          // !el?.adjusttokenamt &&           // ! as discussed then, if token is adjustable in allotment; do not refund
          (el.status === "active" ||
            el.status === "alloted" ||
            el.status === "partial") &&
          el.refundable &&
          // el?.linkedtokenid===null&&
          !el.ispreselect
        ) {
          el.subMenu.push("Token Refund Request");
          el.subMenu.push("View Details");
          //! new Date(el.eventenddatetime).getTime() < new Date().getTime() ?event is closed now
          if (
            !el?.ispreselect &&
            el?.status === "active" &&
            el?.linkedtokenid === null &&
            new Date(el.eventenddatetime).getTime() < new Date().getTime()
          ) {
            el.subMenu.push("Assign New Token");
          }
        }
        //! new Date(el.eventenddatetime).getTime() < new Date().getTime() ?event is closed now
        else if (
          !el?.ispreselect &&
          el?.status === "active" &&
          el?.linkedtokenid === null &&
          new Date(el.eventenddatetime).getTime() < new Date().getTime()
        ) {
          el.subMenu.push("Assign New Token");
          el.subMenu.push("View Details");
        } else {
          el.subMenu.push("View Details");
        }
        let expiryDate = new Date(el?.createdat).setDate(
          new Date(el?.createdat).getDate() + el?.validity
        );
        el.validTill = new Date(expiryDate);
      });
      setDetails(items);
      setPlans([...items]);
      setOpenTab(filterTab[0].value);
      return;
    }

    // if (benefitPlanId) {
    //   setPlanDetail(tokenResponse.data);
    // } else {
    //   tokenResponse.data.map((d, i) => {
    //     items.push({
    //       id: count,
    //       leadName: d?.leadId?.leadReferrerName,
    //       uniqueLeadId: d?.leadId?.leadDisplayId,
    //       projectName: d?.eventTokenId.eventId.title,
    //       amount: d?.amount,
    //       transactionId: d?.transactionId,
    //       status: d?.status,
    //       tokenNumber: d?.eventTokenId?.tokenId.name,
    //       action: count,
    //       ...d,
    //     });

    //     count++;
    //   });

    //   allotmentResponse.data.map((d, i) => {
    //     items.push({
    //       id: count,
    //       leadName: d?.leadId?.leadReferrerName,
    //       uniqueLeadId: d?.leadId?.leadDisplayId,
    //       projectName: d?.unitId?.projectId.projectName,
    //       transactionId: d?.transactionId,
    //       amount: d?.amount,
    //       status: d?.allotmentstatus,
    //       allotmentstatus: d?.status,
    //       ModeOfPayment: d?.paymentmethod.includes("Virtual acc")
    //         ? "Virtual Account"
    //         : d?.paymentmethod,
    //       paymentMethod: d?.transactionType,
    //       action: count,
    //       ...d,
    //     });

    //     count++;
    //   });

    //   setDetails(items);
    //   setPlans([...items]);
    // }
    // console.log("plans", items);
  }

  const infiniteScrollHandler = () => {
    let nextRange = {
      from: range.to + 1,
      to: range.to + 10,
    };
    getPlanWithPaginationForAllotment(
      "",
      "",
      filterBy,
      checked,
      from,
      to,
      selectBulk,
      nextRange
    );
    setRange(nextRange);
  };

  useEffect(() => {
    setLoadingStatus(0);
    setRange({ from: 0, to: 9 });
  }, [mainTabs]);

  async function getPlanWithPaginationForAllotment(
    benefitPlanId,
    planName,
    filterBy,
    checked,
    from,
    to,
    selectBulk,
    range,
    isShowSpinner = true
  ) {
    // setPlans([]);
    try {
      if (isShowSpinner) presentLoader();

      const allotmentResponse = await getAllotmentTransactions(
        benefitPlanId,
        planName,
        checked,
        search,
        filterBy,
        "",
        "",
        range,
        projectStr
      );
      isShowSpinner && dismissLoader();

      const items = [];
      let count = 0;

      let filterTab = mainTabs.filter((e) => e.isSelected === true);
      if (allotmentResponse?.data?.length < 10) {
        setLoadingStatus(1);
      }
      if (filterTab[0].value === "Allotments") {
        allotmentResponse.data.map((d, i) => {
          items.push({
            id: count,
            leadName: d?.leadname,
            uniqueLeadId: d?.leaddisplayid,
            projectName: d?.projectname ? d?.projectname : d?.mergedproject,
            transactionId: d?.transactionid,
            amount: d?.amount,
            status: d?.allotmentstatus,
            allotmentstatus: d?.status,
            // ModeOfPayment: d?.paymentmethod.includes("Virtual acc")
            //   ? "Virtual Account"
            //   : d?.paymentmethod,
            ModeOfPayment: "TEST(((",
            // paymentMethod: d?.paymentmethod.includes("Virtual acc")
            //   ? "Virtual Account"
            //   : d?.paymentmethod,
            subMenuAllotment: [],
            paymentMethod: "TEST999",
            tokenNumber: d?.tokennumber,
            action: count,
            wingName: d?.displaywingname ? d?.displaywingname : d?.wingname ? d?.wingname : d?.mergedwing,
            wingUnit: d?.unitno
              ? d?.unitno
              : d.unit1no.toString() + "-" + d.unit2no.toString(),
            ...d,
          });
          count++;
        });
        items.forEach((el) => {
          if (el?.allotmentstatus === "Cancelled") {
            el.subMenuAllotment.push("View Details");
            if (loggedInUser.roleId.level === 1 && !el?.cancelledinfarvision) {
              el.subMenuAllotment.push("Initiate Refund");
            }
            // if (el.pricingtype !== "preselect" && !el?.paymenttransferred) {
            if (!el?.paymenttransferred) {
              el.subMenuAllotment.push("Alot Unit");
            }
          } else {
            el.subMenuAllotment.push("View Details");
          }
        });
        setDetails([...allotmentTransactions, ...items]);
        // console.log("allotments-Data" , items)
        setAllotmentTransactions([...allotmentTransactions, ...items]);
        setOpenTab(filterTab[0].value);
        return items;
      }

      if (!benefitPlanId) {
        allotmentResponse.data.map((d, i) => {
          items.push({
            id: count,
            leadName: d?.leadId?.leadReferrerName,
            uniqueLeadId: d?.leadId?.leadDisplayId,
            projectName: d?.unitId?.projectId.projectName,
            transactionId: d?.transactionId,
            amount: d?.amount,
            status: d?.allotmentstatus,
            allotmentstatus: d?.status,
            ModeOfPayment: d?.paymentmethod.includes("Virtual acc")
              ? "Virtual Account"
              : d?.paymentmethod,
            paymentMethod: d?.transactionType,
            action: count,
            ...d,
          });

          count++;
        });

        setDetails([...plans, ...items]);
      }
    } catch (err) {
      dismissLoader();
      if (err?.message) {
        if (err?.message === "Requested range not satisfiable") {
          errorTost("No more data!");
        } else {
          errorTost(err?.message);
        }
      }
    }
  }

  async function getPlanWithPaginationForToken(
    benefitPlanId,
    planName,
    filterBy,
    checked,
    from,
    to,
    selectBulk,
    range,
    isShowSpinner = true
  ) {
    // setPlans([]);
    try {
      if (isShowSpinner) presentLoader();
      const tokenResponse = await getPayments(
        benefitPlanId,
        planName,
        checked,
        search,
        filterBy,
        from,
        to,
        selectBulk,
        range
      );

      isShowSpinner && dismissLoader();

      const items = [];
      let count = 0;

      let filterTab = mainTabs.filter((e) => e.isSelected === true);
      if (tokenResponse?.data?.length < 10) {
        setLoadingStatus(1);
      }
      if (filterTab[0].value === "Tokens") {
        tokenResponse.data.map((d, i) => {
          items.push({
            id: count,
            leadName: d?.leadname,
            uniqueLeadId: d?.leaddisplayid,
            projectName: d?.eventname,
            transactionId: d?.transactionid,
            amount: d?.amount,
            status: d?.status,
            tokenNumber: d?.tokennumber,
            action: count,
            selected: d?.refundable ? false : null,
            subMenu: [],
            ...d,
          });
          count++;
        });
        // !!SubMenu
        items.forEach((el) => {
          if (
            // !el?.adjusttokenamt &&           // ! as discussed then, if token is adjustable in allotment; do not refund
            (el.status === "active" ||
              el.status === "alloted" ||
              el.status === "partial") &&
            el.refundable &&
            !el.ispreselect
            // &&
            // el?.linkedtokenid===null
          ) {
            el.subMenu.push("Token Refund Request");
            el.subMenu.push("View Details");
            if (
              !el?.ispreselect &&
              el?.status === "active" &&
              el?.linkedtokenid === null &&
              new Date(el.eventenddatetime).getTime() < new Date().getTime()
            ) {
              el.subMenu.push("Assign New Token");
            }
          } else if (
            !el?.ispreselect &&
            el?.status === "active" &&
            el?.linkedtokenid === null &&
            new Date(el.eventenddatetime).getTime() < new Date().getTime()
          ) {
            el.subMenu.push("Assign New Token");
            el.subMenu.push("View Details");
          } else {
            el.subMenu.push("View Details");
          }
          let expiryDate = new Date(el?.createdat).setDate(
            new Date(el?.createdat).getDate() + el?.validity
          );
          el.validTill = new Date(expiryDate);
        });
        console.log("items--->KK", items);
        // setDetails(items);
        setDetails([...plans, ...items]);
        setPlans([...plans, ...items]);
        setOpenTab(filterTab[0].value);
        return items;
      }

      if (benefitPlanId) {
        setPlanDetail(tokenResponse.data);
      } else {
        tokenResponse.data.map((d, i) => {
          items.push({
            id: count,
            leadName: d?.leadId?.leadReferrerName,
            uniqueLeadId: d?.leadId?.leadDisplayId,
            projectName: d?.eventTokenId.eventId.title,
            amount: d?.amount,
            transactionId: d?.transactionId,
            status: d?.status,
            tokenNumber: d?.eventTokenId?.tokenId.name,
            action: count,
            ...d,
          });

          count++;
        });
        setPlans([...plans, ...items]);
      }
    } catch (err) {
      dismissLoader();
      if (err?.message) {
        if (err?.message === "Requested range not satisfiable") {
          errorTost("No more data!");
        } else {
          errorTost(err?.message);
        }
      }
    }
  }

  const handleFilterTokenApply = async () => {
    // if (checked.length !== 0) {
    setLoadingStatus(0);
    setRange({ from: 0, to: 9 });
    getPlans("", "", filterBy, checked, from, to, selectBulk);
    let filterTab = mainTabs.filter((e) => e.isSelected === true);
    // console.clear();
    const items = [];
    let count = 0;
    if (filterTab[0].value === "Allotments") {
      const allotmentResponse = await getAllotmentTransactions(
        "",
        "",
        checked,
        search,
        filterBy,
        from,
        to,
        undefined,
        projectStr
      );
      setDetails([]);
      setPlans([]);
      setAllotmentTransactions([]);

      const allotmentItems = [];
      let AllotmentCount = 0;
      allotmentResponse.data.map((d, i) => {
        items.push({
          id: count,
          leadName: d?.leadname,
          uniqueLeadId: d?.leaddisplayid,
          projectName: d?.projectname ? d?.projectname : d?.mergedproject,
          transactionId: d?.transactionid,
          amount: d?.amount,
          status: d?.allotmentstatus,
          allotmentstatus: d?.status,

          // ModeOfPayment: d?.paymentmethod.includes("Virtual acc")
          //   ? "Virtual Account"
          //   : d?.paymentmethod,
          // paymentMethod: d?.paymentmethod.includes("Virtual acc")
          //   ? "Virtual Account"
          //   : d?.paymentmethod,
          paymentMethod: "TEST 999",
          ModeOfPayment: "test 999",
          tokenNumber: d?.tokennumber,
          action: count,
          wingName: d?.displaywingname ? d?.displaywingname : d?.wingname ? d?.wingname : d?.mergedwing,
          subMenuAllotment: [],
          wingUnit: d?.unitno
            ? d?.unitno
            : d.unit1no.toString() + "-" + d.unit2no.toString(),
          ...d,
        });

        count++;
      });

      items.forEach((el) => {
        if (el?.allotmentstatus === "Cancelled") {
          el.subMenuAllotment.push("View Details");
          if (loggedInUser.roleId.level === 1 && !el?.cancelledinfarvision) {
            el.subMenuAllotment.push("Initiate Refund");
          }
          // if (el.pricingtype !== "preselect" && !el?.paymenttransferred) {
          if (!el?.paymenttransferred) {
            el.subMenuAllotment.push("Alot Unit");
          }
        } else {
          el.subMenuAllotment.push("View Details");
        }
      });
      setDetails([...items]);
      // console.log("allotments-Data" , items)
      setAllotmentTransactions([...items]);
      setOpenTab(filterTab[0].value);
    } else if (filterTab[0].value === "Tokens") {
      const items = [];
      let count = 0;

      const tokenResponse = await getPayments(
        "",
        "",
        checked,
        search,
        filterBy,
        from,
        to
      );

      // tokenResponse.data.map((d, i) => {
      //   items.push({
      //     id: count,
      //     leadName: d?.leadname,
      //     uniqueLeadId: d?.leaddisplayid,
      //     projectName: d?.eventname,
      //     transactionId: d?.transactionid,
      //     amount: d?.amount,
      //     status: d?.status,
      //     tokenNumber: d?.tokennumber,
      //     action: count,
      //     selected: d?.refundable ? false : null,
      //     subMenu:[],
      //     ...d,
      //   });

      //   count++;
      // });
      tokenResponse.data.map((d, i) => {
        items.push({
          id: count,
          leadName: d?.leadname,
          uniqueLeadId: d?.leaddisplayid,
          projectName: d?.eventname,
          transactionId: d?.transactionid,
          amount: d?.amount,
          status: d?.status,
          tokenNumber: d?.tokennumber,
          action: count,
          selected: d?.refundable ? false : null,
          subMenu: [],
          ...d,
        });

        count++;
      });
      // !!SubMenu
      items.forEach((el) => {
        if (
          // !el?.adjusttokenamt &&                 // ! as discussed then, if token is adjustable in allotment; do not refund
          (el.status === "active" ||
            el.status === "alloted" ||
            el.status === "partial") &&
          el.refundable &&
          // el?.linkedtokenid===null&&
          !el.ispreselect
        ) {
          el.subMenu.push("Token Refund Request");
          el.subMenu.push("View Details");
          if (
            !el?.ispreselect &&
            el?.status === "active" &&
            el?.linkedtokenid === null &&
            new Date(el.eventenddatetime).getTime() < new Date().getTime()
          ) {
            el.subMenu.push("Assign New Token");
          }
        } else if (
          !el?.ispreselect &&
          el?.status === "active" &&
          el?.linkedtokenid === null &&
          new Date(el.eventenddatetime).getTime() < new Date().getTime()
        ) {
          el.subMenu.push("Assign New Token");
          el.subMenu.push("View Details");
        } else {
          el.subMenu.push("View Details");
        }
        let expiryDate = new Date(el?.createdat).setDate(
          new Date(el?.createdat).getDate() + el?.validity
        );
        el.validTill = new Date(expiryDate);
      });
      setDetails(items);
      setPlans([...items]);
    }
    // }
    setFilterOpen(false);
    setDepQuery(filter + JSON.stringify(checked) + JSON.stringify(projectStr));
  };

  const [search, setSearch] = useState();
  // const [searchAllotment, setSearchAllotment] = useState();

  const searchUser = debounce((e) => {
    setSearch(e.target.value);
  }, 800);

  // function searchUserAllotment(e) {
  //   setSearch(e.target.value);
  // }

  const searchUserAllotment = debounce((e) => {
    setSearch(e.target.value);
  }, 800);

  useEffect(() => {
    // insertPlan();
    setChecked([]);
    getSubfilters("None", 0);
    setFilterOpen(false);
    setFrom("");
    setTo("");
    setSearch("");
    filterPaymentBySort("Latest First");
    setFilerByTransaction("Latest First")
    setPageNumber(0)
    searchValueTransaction.current = ""
    setSelectDates([{ label: "StartDate", value: "" },
    { label: "EndDate", value: "" },])
    // getPlans();
  }, [mainTabs]);

  useEffect(() => {
    getPlans("", "", filterBy, checked, from, to, selectBulk);
  }, [search]);
  // useEffect(() => {
  //   getPlanWithPagination("", "", filterBy, checked, from, to, selectBulk);
  // }, [search]);

  async function onTabChange(value) {
    setButtonName("Bulk Refund Request");
    setBulkRequested(false);
    setSelectBulk(false);
    let _pre = [...mainTabs]?.filter(v => v).map((m) => ({ ...m, isSelected: false }));
    _pre[_pre.findIndex((f) => f.value === value)].isSelected = true;
    setMainTabs([..._pre]);
  }

  const plansCard = (allotment) =>
    allotment.map((allotment, index) => {
      return (
        <Grid
          className={classes.Grid}
          item
          xs={4}
          sm={4}
          md={4}
          lg={4}
          key={"allotmentCard" + index}
        >
          <Card
            className={cssClasses2.eventWrap}
            key={allotment.allotmentpaymentid}
          >
            <div
              className={cssClasses2.cardHeader}
              style={{ flexWrap: "wrap" }}
            >
              <div className={cssClasses2.tokenNumWrap}>
                <p>
                  {allotment.leadname}
                  <br />
                  {openTab !== "Tokens" && (
                    <span
                      style={{
                        fontSize: "1.5rem",
                      }}
                    >
                      {allotment?.wingname} - {allotment?.wingUnit} | {allotment.floorno} |{" "}
                      {allotment?.projectName}
                    </span>
                  )}
                </p>{" "}
              </div>

              {/* {openTab !== "Tokens" && (
                <div
                  className={cssClasses.projectName}
                  style={{ flex: "1 0 100%", marginTop: "1rem" }}
                >
                  {allotment?.wingUnit}/{allotment.floorno} |
                  {allotment?.wingName} | {allotment?.projectName}
                </div>
              )} */}
            </div>
            <div
              // className={cssClasses2.projectName}
              style={{ fontSize: "1.5rem", alignSelf: "flex-start" }}
            >
              {"VJ" +
                allotment?.leaddisplayid?.replace(
                  allotment?.leaddisplayid?.substring(8, 12),
                  "-" + allotment?.leaddisplayid?.substring(8, 12)
                )}
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              {/* <div className={cssClasses2.tokenStatus}>
             
            </div> */}
              <div className={cssClasses2.tokenStatus}>
                <StatusChip
                  value={
                    openTab === "Tokens" &&
                      allotment.status !== "expired" &&
                      allotment?.linkedtokenid !== null && allotment.status === "active"
                      ? "Upgraded"
                      : allotment?.status
                  }
                />
              </div>
              {allotment?.paymenttransferred && (
                <div>
                  <LeadStatusChip
                    label={"Payment Transferred"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  ></LeadStatusChip>
                </div>
              )}
              <div className={cssClasses.tokenStatus}>
                {allotment.status?.includes("Payment") &&
                  !allotment.kycformfilled && (
                    <LeadStatusChip
                      label={"Kyc pending"}
                      icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                      style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                    ></LeadStatusChip>
                  )}
                {allotment.kycformfilled && (
                  <LeadStatusChip
                    label={"Kyc Done"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                  ></LeadStatusChip>
                )}
              </div>
              <div className={cssClasses2.tokenActions}>
                <ThreeDotsMenu
                  style={{
                    "& .MuiSvgIcon-root": {
                      fontSize: "3rem !important",
                    },
                  }}
                  list={getList(allotment) || []}
                  selectedValue={(e) => {
                    selectedValueCheck(e, allotment, index);
                    setItemCount(index);
                    setSelectedCard((prev) => ({
                      ...prev,
                      viewDetails: allotment,
                    }));
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div className={cssClasses2.tokenNumWrap}>
                <div>
                  {allotment?.tokenNumber && (
                    <div> VJ{allotment?.tokenNumber}</div>
                  )}
                  <div>{allotment?.tokenname}</div>
                </div>
              </div>
              <div className={cssClasses2.allotmentPaymentId}>
                <p>{allotment.allotmentpaymentid}</p>
              </div>
            </div>
            <div className={cssClasses2.cardDetails}>
              <div className={cssClasses2.tokenDetails}>
                <div
                  className={cssClasses2.tokenData}
                  style={{ justifyContent: "space-between" }}
                >
                  <span>
                    {allotment.eventname ? allotment.eventname : "Sustenance"}
                  </span>
                  {allotment.eventname &&
                    allotment.pricingtype === "preselect" && (
                      <span>
                        <LeadStatusChip
                          label={"Preselect"}
                          style={{
                            color: "#3538CD",
                            backgroundColor: "#EEF4FF",
                          }}
                        ></LeadStatusChip>
                      </span>
                    )}
                  <div className={cssClasses2.tokenLastUpdate}>
                    <ReactTimeAgo
                      style={{ fontSize: "1.2rem" }}
                      date={allotment?.lastupdated ?? allotment?.createdat}
                      locale="en-US"
                    />
                  </div>
                </div>
                <div
                  className={cssClasses2.tokenData}
                  style={{ justifyContent: "space-between" }}
                >
                  <div className={cssClasses2.tokenLastUpdate}>
                    <p>VJ SM - {allotment.username}</p>
                    {allotment?.crmuserid && allotment?.crmusername && (
                      <p>VJ CRM - {allotment.crmusername}</p>
                    )}
                  </div>
                </div>
                <div
                  className={cssClasses2.tokenData}
                  style={{ justifyContent: "space-between" }}
                >
                  <div>
                    {openTab == "Tokens" && (
                      <>
                        <span>Valid Till: </span>
                        <span>
                          {allotment.validTill.toDateString()},
                          {new Date(allotment.validTill).toLocaleTimeString(
                            [],
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}
                          {/* {new Date
                            allotment.createdat + allotment.validity
                          ).toDateString()}
                          ,{" "}
                          {new Date(
                            allotment.createdat || allotment.validity
                          ).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })} */}
                        </span>
                      </>
                    )}
                    {/* {allotment?.displayinventorytype?.includes(
                      "Inventory Type"
                    ) ? (
                      <span>{allotment.unittype}</span>
                    ) : (
                      ""
                    )}
                    {allotment?.displayinventorytype?.includes(
                      "Display Unit Type"
                    ) ? (
                      <span>{"(" + allotment.displayunittype + ")"}</span>
                    ) : (
                      ""
                    )}
                    {!allotment.unittype && (
                      <>
                        <span>Merged</span>
                      </>
                    )} */}
                  </div>
                  <div>
                    <span>Alloted On: </span>
                    <span>
                      {new Date(
                        allotment.allotmentdate || allotment.createdat
                      ).toDateString()}
                      ,{" "}
                      {new Date(
                        allotment.allotmentdate || allotment.createdat
                      ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className={cssClasses2.cardFooter}>
              {subTabs.find((f) => f?.isSelected)?.value !== "On Hold" ? (
                <div className={cssClasses2.paidAmt}>
                  <span>Paid Amount : </span>
                  <span>₹ {numberWithCommas(allotment.paidamount)}</span>
                </div>
              ) : (
                <div className={cssClasses2.paidAmt}>
                  {allotment.unitholdtime && (
                    <ReactTimeAgo
                      style={{ fontSize: "1.2rem" }}
                      date={allotment?.unitholdtime}
                      locale="en-US"
                    />
                  )}
                </div>
              )}
              {/* {(allotment.status === "Partial Payment Done" ||
                  allotment.status === "Preselected" ||
                  allotment.status === "Payment Pending" ||
                  allotment.status === "On Hold") && (
                  <div style={{ display: "flex", gap: "1rem" }}>
                    {allotment.status === "On Hold" && (
                      <Button
                        btnName={"Alot"}
                        clicked={() => {
                          alotUnit(allotment);
                        }}
                        style={{
                          color: "#fff",
                          backgroundColor: "rgb(21, 112, 239)",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          fontFamily: "Inter-Medium !important",
                        }}
                      />
                    )}
                    {subTabs.find((f) => f?.isSelected)?.value !== "On Hold" &&
                      (allotment.status === "Partial Payment Done" ||
                        allotment.status === "Preselected" ||
                        allotment.status === "Payment Pending") && (
                        <Button
                          btnName={"Pay Now 2"}
                          clicked={() => {
                            openModal(allotment);
                          }}
                          style={{
                            width: "100%",
                            color: "#fff",
                            backgroundColor: "rgb(21, 112, 239)",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                            fontFamily: "Inter-Medium !important",
                          }}
                        />
                      )}
                    {subTabs.find((f) => f?.isSelected)?.value === "On Hold" && (
                      <Button
                        btnName={"Release"}
                        clicked={() => {
                          releaseUnit(allotment);
                        }}
                        style={{
                          width: "60%",
                          color: "#fff",
                          backgroundColor: "rgb(21, 112, 239)",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          fontFamily: "Inter-Medium !important",
                        }}
                      />
                    )}
                  </div>
                )} */}
            </div>
          </Card>
        </Grid>
      );
    });

  // const queryClient = new QueryClient()

  const debouncedFetchSearchData = debounce((e) => {
    // searchValue.current = e.target.value;
    setSearchValue(e.target.value);
    // if(searchValue.current) {

    // } else {
    //   allCrmAllotments
    // }
  }, 500);

  const handleFetchChild = (id) => {
    const fetchEvents = async () => {
      const data = await getWingList(id);
      const finalPayload = [...projectList];
      const index = finalPayload.findIndex((i) => i.id === id);
      finalPayload.splice(index, 1, data[0]);
      setProjectList(finalPayload);
    };
    fetchEvents();
  };

  return (
    // <QueryClientProvider queryClient = {queryClient}>
    <div className={cssClasses.pageWrapper}>
      {/* <CheckBoxTreeView />   */}
      {/* <TreeviewCheckbox /> */}
      {/* <CheckboxTreeView2 /> */}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      <div
        className={cssClasses.pageHeadingWrapper}
        style={{ marginTop: "1rem" }}
      >
        <p>Payment</p>
      </div>

      <Box className={cssClasses.TabsWrapper}>
        <TabContext value={mainTabs.find((f) => f.isSelected).value}>
          <TabsMenu
            selectedColor={"#1570EF"}
            selectedBackgroundColor={"#FFFFFF"}
            stylesForTab={{
              color: "#344054",
              fontSize: "1.6rem",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "2.4rem",
              padding: "0.8rem 1.2rem",
              textTransform: "unset",
              borderBottom: "1px solid #EAECF0",
            }}
            borderColor={"#1570EFs"}
            stylesForWrapper={{
              padding: "1.5rem",
              background: "#FFFFFF",
            }}
            list={mainTabs?.filter(val => val)}
            value={mainTabs.find((f) => f?.isSelected).value}
            handleChange={(e, value) => {
              e.preventDefault();
              onTabChange(value);
            }}
          />
          <TabPanel className={cssClasses.tabPanel} value={"Tokens"} index={1} sx={{ padding: "0 24px 24px 24px" }}>
            <Box className={cssClasses.mainTabPanelWrapper}>
              <div className={cssClasses.content}>
                <div className={cssClasses.actionWrapper}>
                  <div className={cssClasses.wrapper}>
                    <div className={cssClasses.filterContainer}>
                      <div className={cssClasses.tokenWrapper}>
                        {paymentCount || 0} Tokens{" "}
                      </div>
                    </div>
                  </div>
                  <div className={cssClasses.searchWrapper}>
                    <div
                      className={cssClasses.filterWrapper}
                      style={{ marginRight: "12px" }}
                    >
                      <div className={cssClasses.label}>
                        <p style={{ marginTop: "8px" }}>Filter by</p>
                      </div>
                      <div
                        className={cssClasses.dropdownWrapper}
                      // style={{ width: "max-content" }}
                      >
                        <DropDownButton
                          style={{
                            color: "#323232",
                            backgroundColor: "#fff",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                            fontFamily: "Roboto-Regular",
                          }}
                          btnName={btnName}
                          btnTextStyle={{ width: "150px" }}
                          // outline={true}
                          clicked={() => handleFilterClose(false)}
                          btnIcon={
                            <ExpandMoreIcon
                              style={{ width: "15px", height: "15px" }}
                            />
                          }
                          iconPosition={"right"}
                        />

                        {filterOpen && (
                          <ClickAwayListener
                            onClickAway={() => {
                              setFilterOpen(false);
                            }}
                          >
                            <div className={cssClasses.filterModalWrapper}>
                              <div className={cssClasses.filterModalChild}>
                                <div style={{ width: "50%" }}>
                                  <List
                                    sx={{
                                      width: "100%",
                                      maxWidth: 360,
                                      bgcolor: "background.paper",
                                    }}
                                    component="nav"
                                    aria-labelledby="nested-list-subheader"
                                  >
                                    {filterObj.map((item, i) => {
                                      return (
                                        <ListItem
                                          key={i}
                                          style={{ padding: "0" }}
                                          onClick={() => {
                                            getSubfilters(item.value, item.id);
                                          }}
                                        >
                                          <ListItemButton>
                                            <ListItemText
                                              primary={item.label}
                                            />

                                            {filterCheck === item.id ? (
                                              <ListItemIcon
                                                style={{ minWidth: "auto" }}
                                              >
                                                <CheckIcon
                                                  fontSize="large"
                                                  color="primary"
                                                />
                                              </ListItemIcon>
                                            ) : (
                                              ""
                                            )}
                                          </ListItemButton>
                                        </ListItem>
                                      );
                                    })}
                                  </List>
                                </div>

                                <div
                                  style={{
                                    width: "50%",
                                    backgroundColor: "#F9FAFB",
                                    borderRadius: "8px",
                                    height: "310px",
                                  }}
                                >
                                  {showProjectList ? (
                                    <Box mt={1}>
                                      <TreeviewCheckbox
                                        isChildFetch
                                        handleFetchChildren={(t) => {
                                          handleFetchChild(t);
                                        }}
                                        data={projectList}
                                        value={projectStr}
                                        onChange={(str) => setProjectStr(str)}
                                      />
                                    </Box>
                                  ) : (
                                    <List
                                      sx={{
                                        // width: "100%",
                                        maxWidth: 360,
                                        bgcolor: "background.#F9FAFB",
                                        overflowY: "auto",
                                        height: "100%",
                                        // border : '1px red solid'
                                      }}
                                    >
                                      {["Users", "CP"].map((fil) => {
                                        return (
                                          <div style={{ margin: "5px" }}>
                                            {fil === filter && (
                                              <SearchBar
                                                placeholder={filter}
                                                search={
                                                  debouncedFetchSearchData
                                                }
                                                id={
                                                  "tagPendingCrmAllotmentLeadName"
                                                }
                                              />
                                            )}
                                          </div>
                                        );
                                      })}
                                      {filterNames.map((item) => {
                                        const labelId = `checkbox-list-label-${item.id}`;

                                        return (
                                          <ListItem
                                            key={item.id}
                                            // secondaryAction={
                                            //     <IconButton edge="end" aria-label="comments">
                                            //         <CommentIcon />
                                            //     </IconButton>
                                            // }
                                            disablePadding
                                          >
                                            <ListItemButton
                                              role={undefined}
                                              onClick={handleToggle(
                                                item.id,
                                                item.filter
                                              )}
                                              dense
                                              sx={{
                                                display: "flex",
                                                alignItems: "start",
                                                gap: "1rem",
                                              }}
                                            >
                                              <ListItemIcon
                                                style={{ minWidth: "auto" }}
                                              >
                                                <Checkbox
                                                  edge="start"
                                                  checked={
                                                    checked.indexOf(
                                                      JSON.stringify({
                                                        value: item.id,
                                                        filter: item.filter,
                                                      })
                                                    ) !== -1
                                                  }
                                                  tabIndex={-1}
                                                  disableRipple
                                                  inputProps={{
                                                    "aria-labelledby": labelId,
                                                  }}
                                                />
                                              </ListItemIcon>
                                              <ListItemText
                                                id={labelId}
                                                primary={item.name}
                                              />
                                            </ListItemButton>
                                          </ListItem>
                                        );
                                      })}
                                    </List>
                                  )}
                                </div>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  // width: "100%",
                                  backgroundColor: "#F9FAFB",
                                  padding: "12px",
                                  borderBottomLeftRadius: "8px",
                                  borderBottomRightRadius: "8px",
                                  borderTop: "1px solid #EAECF0",
                                  justifyContent: "end",
                                  // border : '1px blue solid',
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    width: "100px",
                                    float: "right",
                                    marginRight: "12px",
                                    backgroundColor: "#F9FAFB",
                                  }}
                                >
                                  <Button
                                    style={{
                                      width: "100px",
                                      color: "#323232",
                                      backgroundColor: "#fff",
                                      fontSize: "1.4rem",
                                      lineHeight: "2rem",
                                      fontFamily: "Roboto-Regular",

                                      // marginLeft: "-12px"
                                    }}
                                    btnName={"Clear"}
                                    // outline={true}
                                    clicked={() => handleFilterClose(true)}
                                    // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                                    iconPosition={"left"}
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100px",
                                  }}
                                >
                                  <Button
                                    style={{
                                      color: "#fff",
                                      backgroundColor: "#1570EF",
                                      fontSize: "1.4rem",
                                      lineHeight: "2rem",
                                      fontFamily: "Roboto-Regular",

                                      // marginLeft: "-12px"
                                    }}
                                    btnName={"Apply"}
                                    // outline={true}
                                    clicked={handleFilterTokenApply}
                                    // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                                    iconPosition={"left"}
                                  />
                                </div>
                              </div>
                            </div>
                          </ClickAwayListener>
                        )}
                      </div>
                    </div>
                    <div className={cssClasses.filterWrapper}>
                      <div className={cssClasses.label}>
                        <p style={{ marginTop: "8px" }}>Sort by</p>
                      </div>
                      <div className={cssClasses.dropdownWrapper}>
                        <DropDown
                          onChangeSelect={(e) => {
                            filterPaymentBySort(e);
                          }}
                          selectedValue={filterBy}
                          style={{ background: "#E8F0FE" }}
                          list={lists}
                        />
                      </div>
                    </div>
                    <div
                      className={cssClasses.filterWrapper}
                      style={{ marginLeft: "1em" }}
                    >
                      <ViewToggleSwitch
                        setMode={setView}
                        disable={buttonName !== "Bulk Refund Request"}
                      />
                    </div>
                    <div
                      onClick={() => { }}
                      style={{ minWidth: "190px", maxWidth: "220px" }}
                    >
                      <Button
                        style={{
                          color: "#fff",
                          backgroundColor: "#1570EF",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          fontFamily: "Inter-Medium !important",
                        }}
                        btnName={buttonName}
                        isLoading={bulkRequested}
                        disable={bulkRequested}
                        clicked={() => {
                          if (buttonName === "Bulk Refund Request") {
                            setButtonName("Request Initiate");
                            setView("Table View");

                            setSelectBulk(true);
                            getPlans("", "", filterBy, checked, from, to, true);
                          } else {
                            let array = Object.values(details);
                            let filteredTokens =
                              selectedRequestToInitiate.filter(
                                ({ selected }) => selected === true
                              );

                            let count = 0;
                            let flag = false;
                            if (filteredTokens.length > 0) {
                              setBulkRequested(true);

                              filteredTokens.forEach((lead) => {
                                //! **Bulk Request query
                                tokenRefundRequest(
                                  loggedInUser.userId,
                                  lead.paymentid,
                                  `${loggedInUser.name} has done bulk request`,
                                  "pending"
                                )
                                  .then((resp) => {
                                    updateLeadAllStatus(
                                      lead?.leadid,
                                      "Token Refund Requested"
                                    )
                                      .then((updateLeadStatus) => {
                                        // !token status also change from complete to refund requested
                                        updateLeadTokenStatus(
                                          lead?.leadid,
                                          "refund requested",
                                          lead.paymentid
                                        )
                                          .then((resp) => {
                                            count = count + 1;
                                            if (
                                              count === filteredTokens.length
                                            ) {
                                              setButtonName(
                                                "Bulk Refund Request"
                                              );
                                              setBulkRequested(false);
                                              setSelectBulk(false);
                                              successTost(
                                                "All Bulk requests done successfully"
                                              );
                                              setSelectedRequestToInitiate([]);
                                              setPlanDetail([]);
                                              getPlans(
                                                "",
                                                "",
                                                filterBy,
                                                checked,
                                                from,
                                                to,
                                                false
                                              );
                                            }
                                          })
                                          .catch((errResp) => {
                                            setButtonName(
                                              "Bulk Refund Request"
                                            );
                                            setSelectedRequestToInitiate([]);
                                            setBulkRequested(false);
                                            setSelectBulk(false);
                                          });
                                      })
                                      .catch((errWhileUpdating) => {
                                        setSelectedRequestToInitiate([]);
                                        setButtonName("Bulk Refund Request");
                                        setBulkRequested(false);
                                        setSelectBulk(false);
                                      });
                                  })
                                  .catch((err) => {
                                    setSelectedRequestToInitiate([]);
                                    setButtonName("Bulk Refund Request");
                                    setBulkRequested(false);
                                    setSelectBulk(false);
                                    errorTost(err.message);
                                  });
                              });
                              // **flag is for if we didn't found any filtered array and count===0
                            } else {
                              errorTost("Please select at least one token");
                            }
                          }
                        }}
                      />
                    </div>
                    {buttonName === "Request Initiate" && (
                      <div>
                        <Button
                          style={{
                            color: "#1570EF",
                            backgroundColor: "#fff",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                            fontFamily: "Inter-Medium !important",
                          }}
                          btnName={"Cancel"}
                          disable={bulkRequested}
                          clicked={() => {
                            setButtonName("Bulk Refund Request");
                            setBulkRequested(false);
                            setView("Grid View");
                            setSelectBulk(false);
                            setTypeMode("Card View");
                            getPlans(
                              "",
                              "",
                              filterBy,
                              checked,
                              from,
                              to,
                              false
                            );
                          }}
                        />
                      </div>
                    )}
                    <div>
                      <SearchBar
                        sxStyle={{
                          width: "240px",
                        }}
                        placeholder={"Search by Token or Lead name"}
                        search={searchUser}
                        id={"userSearchBar"}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={cssClasses.gridWrapper}
                  style={{
                    justifyContent: "center",
                  }}
                >
                  {/* <Datagrid
                    //  pageChanged={pageChanged}
                    hideFooter={false}
                    columns={userGridColumns}
                    // uniqBy(plans,openTab==='Token'?'paymentid':'transactionid')
                    rows={plans}
                    quickFilterValues={["admin"]}
                    //  filterModel={filterModel}
                  /> */}

                  {plans.length > 0 ? (
                    view === "Table View" ? (
                      <ServerPaginationGrid
                        name="payments-token"
                        columns={userGridColumns}
                        rows={plans}
                        count={paymentCount}
                        getDataByPage={getPaymentsForDatagrid}
                        // dependecies={{
                        //    filter, checked
                        // }}
                        depStr={depStr}
                      />
                    ) : (
                      <Box
                        className={cssClasses.mainTabPanelWrapper}
                        sx={{ flex: "1" }}
                      >
                        <Box sx={{ flexGrow: 1 }}>
                          <InfiniteScroll
                            dataLength={plans.length}
                            next={() => {
                              let nextRange = {
                                from: range.to + 1,
                                to: range.to + 10,
                              };
                              getPlanWithPaginationForToken(
                                "",
                                "",
                                filterBy,
                                checked,
                                from,
                                to,
                                selectBulk,
                                nextRange
                              );
                              setRange(nextRange);
                            }}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              overflowY: "auto",
                            }} //To put endMessage and loader to the top.
                            hasMore={loadingStatus === 0}
                            // loader={<h4>Loading...</h4>}
                            scrollableTarget="scrollableDiv"
                          >
                            <Grid
                              style={{
                                marginTop: "0rem",
                                marginBottom: "1rem",
                                marginLeft: "0rem",
                                width: "100%",
                                height: "calc(100vh - 350px)",
                                // border : '1px red solid',
                                overflow: "auto",
                              }}
                              container
                              spacing={{ xs: 2, md: 3, lg: 3 }}
                              columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
                              id="scrollableDiv"
                            >
                              {plansCard(plans)}
                            </Grid>
                          </InfiniteScroll>
                        </Box>
                      </Box>
                    )
                  ) : (
                    <div
                      style={{
                        height: "100%",
                        display: "grid",
                        placeContent: "center",
                      }}
                    >
                      <img src={NoPaymentsDonePng} alt="" />
                      {/* <p
                        style={{
                          position: "relative",
                          top: "50%",
                          transform: "translateY(-50%)",
                          textAlign: "center",
                          fontSize: "3rem",
                          width: "100%",
                        }}
                      >
                        No Data Available
                      </p> */}
                    </div>
                  )}
                </div>
              </div>
            </Box>
          </TabPanel>
          <TabPanel
            className={cssClasses.tabPanel}
            value={"Allotments"}
            index={2}
          >
            <Box className={cssClasses.mainTabPanelWrapper}>
              <div className={cssClasses.content}>
                <div className={cssClasses.actionWrapper}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      // width: "60%",
                    }}
                  >
                    <div
                      style={{
                        fontFamily: "Inter-Medium",
                        fontStyle: "normal",
                        fontWeight: "500",
                        fontSize: "1.8rem",
                        lineHeight: "2.8rem",
                        color: "#101828",
                        // alignSelf: "center",
                        marginBottom: "1rem",
                        marginRight: "1.5rem",
                        minWidth: "150px",
                      }}
                    >
                      {allotmentCount || 0} Allotments{" "}
                    </div>
                  </div>

                  <div className={cssClasses.searchWrapper}>
                    <div
                      className={cssClasses.filterWrapper}
                      style={{ marginRight: "12px" }}
                    >
                      <div className={cssClasses.label}>
                        <p style={{ marginTop: "8px" }}>Filter by</p>
                      </div>
                      <div className={cssClasses.dropdownWrapper}>
                        <DropDownButton
                          style={{
                            color: "#323232",
                            backgroundColor: "#fff",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                            fontFamily: "Roboto-Regular",
                          }}
                          btnTextStyle={{ width: "150px" }}
                          btnName={btnName}
                          // outline={true}
                          clicked={() => handleFilterClose(false)}
                          btnIcon={
                            <ExpandMoreIcon
                              style={{ width: "15px", height: "15px" }}
                            />
                          }
                          iconPosition={"right"}
                        />
                        {filterOpen && (
                          <ClickAwayListener
                            onClickAway={() => {
                              setFilterOpen(false);
                            }}
                          >
                            <div className={cssClasses.filterModalWrapper}>
                              <div className={cssClasses.filterModalChild}>
                                <div style={{ width: "50%" }}>
                                  <List
                                    sx={{
                                      width: "100%",
                                      maxWidth: 360,
                                      bgcolor: "background.paper",
                                    }}
                                    component="nav"
                                    aria-labelledby="nested-list-subheader"
                                  >
                                    {filterObj.map((item, i) => {
                                      return (
                                        <ListItem
                                          key={i}
                                          style={{ padding: "0" }}
                                          onClick={() => {
                                            getSubfilters(item.value, item.id);
                                          }}
                                        >
                                          <ListItemButton>
                                            <ListItemText
                                              primary={item.label}
                                            />

                                            {filterCheck === item.id ? (
                                              <ListItemIcon
                                                style={{ minWidth: "auto" }}
                                              >
                                                <CheckIcon
                                                  fontSize="large"
                                                  color="primary"
                                                />
                                              </ListItemIcon>
                                            ) : (
                                              ""
                                            )}
                                          </ListItemButton>
                                        </ListItem>
                                      );
                                    })}
                                  </List>
                                </div>

                                <div
                                  style={{
                                    width: "50%",
                                    backgroundColor: "#F9FAFB",
                                    borderRadius: "8px",
                                    height: "352px",
                                    overflow: "auto",
                                  }}
                                >
                                  {filter === "Projects" && (
                                    <div style={{ marginTop: "5px" }}>
                                      <SearchBar
                                        placeholder={"Search "}
                                        search={debouncedFetchSearchData}
                                        id={"projectSerchByName"}
                                      />
                                    </div>
                                  )}
                                  {showProjectList ? (
                                    <Box mt={1}>
                                      <TreeviewCheckbox
                                        data={projectList}
                                        isChildFetch
                                        handleFetchChildren={(t) => {
                                          handleFetchChild(t);
                                        }}
                                        selectedCheckboxes={projectSelected}
                                        onSelectCheckbox={setProjectSelected}
                                        onChange={(str) => {
                                          setProjectStr(str);
                                          setChecked((prev) => [
                                            ...prev,
                                            JSON.stringify({
                                              value: "undefined",
                                              filter: "Projects",
                                            }),
                                          ]);
                                        }}
                                      />
                                    </Box>
                                  ) : (
                                    <List
                                      sx={{
                                        // width: "100%",
                                        maxWidth: 360,
                                        bgcolor: "background.#F9FAFB",
                                        overflowY: "scroll",
                                        height: "352px",
                                      }}
                                    >
                                      {["Users", "CP"].map((fil) => {
                                        return (
                                          <div style={{ margin: "5px" }}>
                                            {fil === filter && (
                                              <SearchBar
                                                placeholder={filter}
                                                search={
                                                  debouncedFetchSearchData
                                                }
                                                id={
                                                  "tagPendingCrmAllotmentLeadName"
                                                }
                                              />
                                            )}
                                          </div>
                                        );
                                      })}
                                      {filterNames.map((item, i) => {
                                        const labelId = `checkbox-list-label-${item.id}`;

                                        return (
                                          <ListItem
                                            key={i}
                                            // secondaryAction={
                                            //     <IconButton edge="end" aria-label="comments">
                                            //         <CommentIcon />
                                            //     </IconButton>
                                            // }
                                            disablePadding
                                          >
                                            <ListItemButton
                                              role={undefined}
                                              onClick={handleToggle(
                                                item.id,
                                                item.filter
                                              )}
                                              dense
                                              sx={{
                                                display: "flex",
                                                alignItems: "start",
                                                gap: "1rem",
                                              }}
                                            >
                                              <ListItemIcon
                                                style={{ minWidth: "auto" }}
                                              >
                                                <Checkbox
                                                  edge="start"
                                                  checked={
                                                    checked.indexOf(
                                                      JSON.stringify({
                                                        value: item.id,
                                                        filter: item.filter,
                                                      })
                                                    ) !== -1
                                                  }
                                                  tabIndex={-1}
                                                  disableRipple
                                                  inputProps={{
                                                    "aria-labelledby": labelId,
                                                  }}
                                                />
                                              </ListItemIcon>
                                              <ListItemText
                                                id={labelId}
                                                primary={item.name}
                                              />
                                            </ListItemButton>
                                          </ListItem>
                                        );
                                      })}
                                    </List>
                                  )}
                                </div>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  // width: "100%",
                                  backgroundColor: "#F9FAFB",
                                  padding: "12px",
                                  borderBottomLeftRadius: "8px",
                                  borderBottomRightRadius: "8px",
                                  borderTop: "1px solid #EAECF0",
                                  justifyContent: "end",
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    width: "100px",
                                    float: "right",
                                    marginRight: "12px",
                                    backgroundColor: "#F9FAFB",
                                  }}
                                >
                                  <Button
                                    style={{
                                      width: "100px",
                                      color: "#323232",
                                      backgroundColor: "#fff",
                                      fontSize: "1.4rem",
                                      lineHeight: "2rem",
                                      fontFamily: "Roboto-Regular",

                                      // marginLeft: "-12px"
                                    }}
                                    btnName={"Clear"}
                                    // outline={true}
                                    clicked={() => handleFilterClose(true)}
                                    // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                                    iconPosition={"left"}
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100px",
                                  }}
                                >
                                  <Button
                                    style={{
                                      color: "#fff",
                                      backgroundColor: "#1570EF",
                                      fontSize: "1.4rem",
                                      lineHeight: "2rem",
                                      fontFamily: "Roboto-Regular",

                                      // marginLeft: "-12px"
                                    }}
                                    btnName={"Apply"}
                                    // outline={true}
                                    clicked={handleFilterTokenApply}
                                    // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                                    iconPosition={"left"}
                                  />
                                </div>
                              </div>
                            </div>
                          </ClickAwayListener>
                        )}
                      </div>
                    </div>

                    <div className={cssClasses.filterWrapper}>
                      <div className={cssClasses.label}>
                        <p style={{ marginTop: "8px" }}>Sort by</p>
                      </div>
                      <div className={cssClasses.dropdownWrapper}>
                        <DropDown
                          onChangeSelect={(e) => {
                            filterPaymentBySort(e);
                          }}
                          selectedValue={filterBy}
                          style={{
                            selectedColor: "#175CD3",
                            background: "#E8F0FE",
                          }}
                          list={lists}
                        />
                      </div>
                    </div>
                    <div
                      className={cssClasses.filterWrapper}
                      style={{ marginLeft: "1em" }}
                    >
                      <ViewToggleSwitch setMode={setView} />
                    </div>
                    <SearchBar
                      sxStyle={{
                        width: "240px",
                      }}
                      placeholder={"Search by Unit or Lead name"}
                      search={searchUserAllotment}
                      id={"userSearchBar"}
                    />
                  </div>
                </div>
                <div className={cssClasses.gridWrapper}>
                  {/* <Datagrid
                    //  pageChanged={pageChanged} 
                    hideFooter={false}
                    columns={userGridColumns}
                    rows={allotmentTransactions}
                    quickFilterValues={["admin"]}

                    // filterModel={filterModel}
                  /> */}
                  {allotmentTransactions.length > 0 ? (
                    view === "Table View" ? (
                      <ServerPaginationGrid
                        name="payments-allotments"
                        columns={userGridColumnsAllotments}
                        // rows={plans}
                        count={allotmentCount}
                        getDataByPage={getPaymentsForDatagrid}
                        depStr={depStr}
                      />
                    ) : (
                      <Box
                        className={cssClasses.mainTabPanelWrapper}
                        sx={{ flex: "1" }}
                      >
                        <Box sx={{ flexGrow: 1 }}>
                          <InfiniteScroll
                            dataLength={allotmentTransactions.length}
                            next={infiniteScrollHandler}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              overflowY: "auto",
                            }} //To put endMessage and loader to the top.
                            hasMore={loadingStatus === 0}
                            // loader={<h4>Loading...</h4>}
                            scrollableTarget="scrollableDiv"
                          >
                            <Grid
                              style={{
                                marginTop: "0rem",
                                marginBottom: "1rem",
                                marginLeft: "0rem",
                                width: "100%",
                                height: "calc(100vh - 350px)",
                                // border : '1px red solid',
                                overflow: "auto",
                              }}
                              container
                              spacing={{ xs: 2, md: 3, lg: 3 }}
                              columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
                              id="scrollableDiv"
                            >
                              {plansCard(allotmentTransactions)}
                            </Grid>
                          </InfiniteScroll>
                        </Box>
                      </Box>
                    )
                  ) : (
                    <div
                      style={{
                        height: "100%",
                        display: "grid",
                        placeContent: "center",
                        margin: "auto",
                      }}
                    >
                      <img src={NoPaymentsDonePng} alt="" />
                    </div>
                  )}
                </div>
              </div>
            </Box>
          </TabPanel>
          <TabPanel className={cssClasses.tabPanel} value={"Transactions"} index={3} sx={{ padding: "0 24px 24px 24px" }}>
            <div className={cssClasses.wrapperPage}>

              {/* Summary Cards */}
              <div
                style={{
                  display: "flex",
                  gap: "0.6rem",
                  flexWrap: window.innerWidth < 820 ? "wrap" : "nowrap",
                  marginBottom: "1.6rem",
                  flexShrink: 0,
                }}
              >
                {[
                  { label: "Total", count: totalCount || 0, amount: null, color: "#175CD3", bg: "#EFF8FF" },
                  { label: "Tagged", count: transactionSummary.tagged.count, amount: transactionSummary.tagged.amount, color: "#027A48", bg: "#ECFDF3" },
                  { label: "Untagged", count: transactionSummary.untagged.count, amount: transactionSummary.untagged.amount, color: "#B54708", bg: "#FFFAEB" },
                  { label: "Refunded", count: transactionSummary.refunded.count, amount: transactionSummary.refunded.amount, color: "#633806", bg: "#FAEEDA" },
                ].map((item, idx) => (
                  <div
                    key={idx}
                    style={{
                      flex: "1",
                      minWidth: window.innerWidth < 820 ? "calc(50% - 0.6rem)" : "unset",
                      background: item.bg,
                      borderRadius: "0.8rem",
                      padding: "0.6rem 1rem",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "1.2rem",
                        fontFamily: "Inter-Medium",
                        color: "#667085",
                        marginBottom: "0.2rem",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item.label}
                    </div>
                    <div
                      style={{
                        fontSize: "2rem",
                        fontFamily: "Inter-Medium",
                        fontWeight: "500",
                        color: item.color,
                      }}
                    >
                      {item.count}
                      {item.amount !== null && (
                        <span style={{ fontSize: "1.3rem", fontWeight: "400", marginLeft: "0.6rem" }}>
                          ₹ {numberWithCommas(item.amount)}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className={cssClasses.contentWrapper}>
                <div className={cssClasses.tokenWrapper} style={{ display: "flex", alignItems: "end" }}>
                  {totalCount || 0} Transactions{" "}
                </div>
                <div className={cssClasses.filterWrapper} style={{ alignItems: "end" }}>
                  <div className={cssClasses.filterSortWrapper}>
                    <div
                      className={cssClasses.label}
                      style={{ marginBottom: "0px", width: "100%" }}
                    >
                      <p style={{ margin: "2px 0", fontSize: "1.6rem" }}>Sort by</p>
                    </div>
                    <div className={cssClasses.dropdownWrapper}>
                      <DropDown
                        onChangeSelect={(e) => {
                          setPageNumber(0)
                          setFilerByTransaction(e);
                        }}
                        selectedValue={filterByTransaction}
                        style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
                        list={["Oldest First", "Latest First"]}
                      />
                    </div>
                  </div>

                  <div className={cssClasses.dateFilterWrapper}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <span style={{ fontSize: "1.6rem" }}>Start Date</span>
                      <DateComponent
                        minDate={new Date("01/01/2023")}
                        maxDate={
                          selectDates[1]?.value !== ""
                            ? new Date(selectDates[1]?.value)
                            : new Date()
                        }
                        value={selectDates[0].value}
                        helperText={helperText?.startDate}
                        onChangeDate={(value) => {
                          setPageNumber(0)
                          setSelectDates((pre) => {
                            pre[0].value = value;
                            return { ...pre };
                          });
                          setHelperText((pre) => {
                            pre.endDate = "";
                            return { ...pre };
                          });
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <span style={{ fontSize: "1.6rem" }}>End Date</span>
                      <DateComponent
                        minDate={new Date(selectDates[0]?.value)}
                        maxDate={new Date()}
                        disabled={selectDates[0]?.value === ""}
                        value={selectDates[1].value}
                        helperText={helperText?.endDate}
                        onChangeDate={(value) => {
                          if (selectDates[0].value === "") {
                            setHelperText((pre) => {
                              pre.endDate = "Please select start date first";
                              return { ...pre };
                            });
                          } else {
                            if (selectDates[0].value > value) {
                              setHelperText((pre) => {
                                pre.endDate = "Select End Date Greater than start Date";
                                return { ...pre };
                              });
                              setSelectDates((pre) => {
                                pre[1].value = "";
                                return { ...pre };
                              });
                            } else {
                              setPageNumber(0)
                              setSelectDates((pre) => {
                                pre[1].value = value;
                                return { ...pre };
                              });
                              setHelperText((pre) => {
                                pre.endDate = "";
                                return { ...pre };
                              });
                              setIsEndDateNotNull(true);
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className={cssClasses.searchBar}>
                    <SearchBar
                      placeholder={"Search by pay id or lead name"}
                      search={debouncedFetchSearchDataForTransaction}
                      id={"transaction"}
                      width={"30rem"}
                    />
                  </div>
                </div>
              </div>

              <div className={cssClasses.tableWrapper}>
                {allTransactions?.length > 0 ? (
                  <DataGrid
                    rows={allTransactions}
                    columns={tagGridColumns?.filter(val => val)}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    page={pageMaintain}
                    onPageChange={(_page) => {
                      setPageMaintain(_page);
                      if (pageNumber < _page) {
                        getMoreData(_page);
                      }
                    }}
                    onCellClick={(params) => {
                      if (params.field === "Actions") return;
                      setDetailTransaction(params.row);
                      setTransactionDetailModal(true);
                    }}
                    sx={[dataGridStyles, { "& .MuiDataGrid-row": { cursor: "pointer" } }]}
                  />
                ) : (
                  <div style={{ height: "100%" }}>
                    <p
                      style={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translateY(50%)",
                        textAlign: "center",
                        fontSize: "3rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img src={EmptyState} alt="No Data" />
                        <span>No Transactions Available</span>
                      </div>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </TabPanel>
        </TabContext>
      </Box>







      {transactionDetailModal && (
        <Modal
          open={transactionDetailModal}
          onClose={() => {
            setTransactionDetailModal(false);
            setDetailTransaction(null);
          }}
          aria-labelledby="transaction-timeline-modal"
        >
          <Box className={cssClasses.wrapperModal}>
            {/* Header */}
            <div className={cssClasses.paymentDetailsWrapperHeader}>
              <span>Transaction Timeline</span>
              <CloseIcon
                fontSize="large"
                onClick={() => {
                  setTransactionDetailModal(false);
                  setDetailTransaction(null);
                }}
                style={{ cursor: "pointer" }}
              />
            </div>

            {/* Transaction Info */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: window.innerWidth < 820 ? "1rem" : "1.6rem",
                padding: window.innerWidth < 820 ? "1.2rem 1.6rem" : "1.6rem 2rem",
                borderBottom: "1px solid #EAECF0",
                backgroundColor: "#fff",
              }}
            >
              {[
                ["Lead Name", detailTransaction?.leadname || "-"],
                [
                  "CUID",
                  detailTransaction?.leaddisplayid
                    ? "VJ" +
                      detailTransaction.leaddisplayid.replace(
                        detailTransaction.leaddisplayid.substring(8, 12),
                        "-" + detailTransaction.leaddisplayid.substring(8, 12)
                      )
                    : "-",
                ],
                ["Amount", `₹${numberWithCommas(detailTransaction?.amount)}`],
                ["Mode of Payment", detailTransaction?.modeofpayment || "-"],
                ["Pay ID", detailTransaction?.payid || "-"],
                [
                  "Received On",
                  detailTransaction?.last_updated_at
                    ? new Date(detailTransaction.last_updated_at).toDateString() +
                      ", " +
                      new Date(detailTransaction.last_updated_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "-",
                ],
              ].map(([label, value]) => (
                <div key={label} style={{ minWidth: "14rem" }}>
                  <div
                    style={{
                      fontSize: "1.2rem",
                      fontFamily: "Inter-Medium",
                      color: "#98A2B3",
                      marginBottom: "0.4rem",
                    }}
                  >
                    {label}
                  </div>
                  <div
                    style={{
                      fontSize: "1.4rem",
                      fontFamily: "Inter-Medium",
                      color: "#101828",
                      wordBreak: label === "Pay ID" ? "break-all" : "normal",
                    }}
                  >
                    {value}
                  </div>
                </div>
              ))}
            </div>

            {/* Timeline */}
            <div
              className={cssClasses.paymentDetailsWrapper}
              style={{
                overflowY: "auto",
                maxHeight: window.innerWidth < 820 ? "55vh" : "40rem",
              }}
            >
              <div
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#344054",
                  marginBottom: "0.8rem",
                  fontWeight: "500",
                }}
              >
                Payment Journey
              </div>
              <Timeline
                position="right"
                sx={[
                  {
                    padding: "0rem !important",
                    [`& .MuiTimeline-root`]: { padding: "0rem !important" },
                    [`& .MuiTimelineItem-root:before`]: {
                      flex: "0rem !important",
                      padding: "0rem !important",
                      "-webkitFlex": "none !important",
                    },
                  },
                ]}
              >
                {/* Step 1 — Payment Received — always shown */}
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }}>
                      <DoneIcon style={{ color: "#0BA5EC", fontSize: "1.6rem" }} />
                    </TimelineDot>
                    <TimelineConnector sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }} />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography fontSize={"1.4rem"} style={{ paddingTop: "0rem" }}>
                      <div
                        style={{
                          fontSize: "1.4rem",
                          fontFamily: "Inter-Medium",
                          color: "#000000",
                          lineHeight: "2rem",
                          marginBottom: "0.4rem",
                        }}
                      >
                        Payment Received
                      </div>
                      <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#475467", lineHeight: "1.8rem" }}>
                        ₹{numberWithCommas(detailTransaction?.amount)}
                      </div>
                      <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#475467", lineHeight: "1.8rem" }}>
                        {detailTransaction?.last_updated_at
                          ? new Date(detailTransaction.last_updated_at).toDateString() +
                            ", " +
                            new Date(detailTransaction.last_updated_at).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : "-"}
                      </div>
                      <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#475467", lineHeight: "1.8rem" }}>
                        Via {detailTransaction?.modeofpayment || "-"}
                      </div>
                    </Typography>
                  </TimelineContent>
                </TimelineItem>

                {/* Step 2 — Marked as Untagged — always shown */}
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }}>
                      <DoneIcon style={{ color: "#0BA5EC", fontSize: "1.6rem" }} />
                    </TimelineDot>
                    <TimelineConnector sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }} />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography fontSize={"1.4rem"} style={{ paddingTop: "0rem" }}>
                      <div
                        style={{
                          fontSize: "1.4rem",
                          fontFamily: "Inter-Medium",
                          color: "#000000",
                          lineHeight: "2rem",
                          marginBottom: "0.4rem",
                        }}
                      >
                        Marked as Untagged
                      </div>
                      <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#475467", lineHeight: "1.8rem" }}>
                        Could not be auto-matched to any booking or token
                      </div>
                      <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#475467", lineHeight: "1.8rem" }}>
                        Pay ID: {detailTransaction?.payid || "-"}
                      </div>
                    </Typography>
                  </TimelineContent>
                </TimelineItem>

                {/* Step 3 — Final Status — a transaction can be BOTH partially tagged and
                    still have money awaiting action, so these are no longer mutually exclusive
                    branches: refunded/tagged/awaiting-action only decide the status chip, while
                    "already tagged" and "possible matches" each render independently below it
                    based on what's actually there. */}
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: detailTransaction?.refunded
                          ? "rgba(11, 165, 236, 0.3)"
                          : detailTransaction?.tagged
                          ? "rgba(11, 165, 236, 0.3)"
                          : "rgba(136, 135, 128, 0.2)",
                      }}
                    >
                      <DoneIcon
                        style={{
                          color: detailTransaction?.refunded || detailTransaction?.tagged ? "#0BA5EC" : "#888780",
                          fontSize: "1.6rem",
                        }}
                      />
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography fontSize={"1.4rem"} style={{ paddingTop: "0rem" }}>
                      <div
                        style={{
                          fontSize: "1.4rem",
                          fontFamily: "Inter-Medium",
                          color: detailTransaction?.refunded || detailTransaction?.tagged ? "#000000" : "#667085",
                          lineHeight: "2rem",
                          marginBottom: "0.4rem",
                        }}
                      >
                        {detailTransaction?.refunded
                          ? "Refunded"
                          : detailTransaction?.tagged
                          ? "Tagged"
                          : taggedTarget.tokens.length > 0 || taggedTarget.allotments.length > 0
                          ? "Partially Tagged"
                          : "Awaiting Action"}
                      </div>
                      <LeadStatusChip
                        label={
                          detailTransaction?.refunded
                            ? "Refunded"
                            : detailTransaction?.tagged
                            ? "Tagged"
                            : taggedTarget.tokens.length > 0 || taggedTarget.allotments.length > 0
                            ? "Partially Tagged"
                            : "Awaiting Action"
                        }
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={
                          detailTransaction?.refunded
                            ? { color: "#633806", backgroundColor: "#FAEEDA" }
                            : detailTransaction?.tagged
                            ? { color: "#027A48", backgroundColor: "#ECFDF3" }
                            : taggedTarget.tokens.length > 0 || taggedTarget.allotments.length > 0
                            ? { color: "#B54708", backgroundColor: "#FFFAEB" }
                            : { color: "#475467", backgroundColor: "#F2F4F7" }
                        }
                      />

                      {!detailTransaction?.refunded &&
                        !detailTransaction?.tagged &&
                        taggedTarget.tokens.length === 0 &&
                        taggedTarget.allotments.length === 0 &&
                        !taggedTargetLoading && (
                          <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#475467", lineHeight: "1.8rem", marginTop: "0.6rem" }}>
                            No action taken yet. Use Refund, Auto-tag, or Manual Tag from the action menu.
                          </div>
                        )}

                      {/* Already tagged — whatever has actually been placed against this pay ID so far,
                          regardless of whether the transaction is fully or only partially tagged. */}
                      {taggedTargetLoading ? (
                        <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#475467", lineHeight: "1.8rem", marginTop: "0.6rem" }}>
                          Looking up where this was tagged…
                        </div>
                      ) : (
                        (taggedTarget.tokens.length > 0 || taggedTarget.allotments.length > 0) && (
                          <div style={{ marginTop: "1.2rem" }}>
                            <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#344054", fontWeight: "500", marginBottom: "0.6rem" }}>
                              Already tagged
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
                              {taggedTarget.tokens.map((t) => (
                                <div
                                  key={t.transactionId}
                                  style={{ background: "#EEEDFE", borderRadius: "0.6rem", padding: "0.6rem 1rem" }}
                                >
                                  <LeadStatusChip
                                    label={"Token"}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#3C3489", backgroundColor: "#fff" }}
                                  />
                                  <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#475467", marginTop: "0.4rem" }}>
                                    ₹{numberWithCommas(t.amount)} · Event Token ID: {t.eventTokenId || "-"} · {t.status}
                                  </div>
                                </div>
                              ))}
                              {taggedTarget.allotments.map((a) => (
                                <div
                                  key={a.transactionId}
                                  style={{ background: "#E6F1FB", borderRadius: "0.6rem", padding: "0.6rem 1rem" }}
                                >
                                  <LeadStatusChip
                                    label={"Allotment"}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#0C447C", backgroundColor: "#fff" }}
                                  />
                                  <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#475467", marginTop: "0.4rem" }}>
                                    ₹{numberWithCommas(a.amount)} · {a.transactionType || "-"} · {a.status}
                                  </div>
                                  <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#475467" }}>
                                    Allotment Payment ID: {a.allotmentPaymentId || "-"}
                                  </div>
                                  <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#475467" }}>
                                    Unit {a.Inventory?.unitNo || "-"}
                                    {a.Inventory?.floorNo ? `, ${a.Inventory.floorNo}` : ""}
                                    {a.Inventory?.Wings?.wingName ? `, ${a.Inventory.Wings.wingName}` : ""}
                                    {a.Inventory?.Projects?.projectName ? ` — ${a.Inventory.Projects.projectName}` : ""}
                                  </div>
                                  <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#475467" }}>
                                    OCR ₹{numberWithCommas(a.ocr)} · GST ₹{numberWithCommas(a.gst)} · SDR ₹{numberWithCommas(a.sdr)}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )
                      )}

                      {/* Still-untagged remainder — only meaningful while the transaction isn't
                          fully tagged or refunded, independent of whether something is already tagged. */}
                      {!detailTransaction?.tagged && !detailTransaction?.refunded && (
                        <div style={{ marginTop: "1.2rem" }}>
                          <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#344054", fontWeight: "500", marginBottom: "0.6rem" }}>
                            Possible matches for the remaining ₹{numberWithCommas(detailTransaction?.amount)}
                          </div>
                          {pendingDuesLoading ? (
                            <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#475467" }}>
                              Checking this lead's pending tokens and allotments…
                            </div>
                          ) : pendingDues.tokens.length === 0 && pendingDues.allotments.length === 0 ? (
                            <div style={{ fontSize: "1.4rem", fontFamily: "Inter-Medium", color: "#475467" }}>
                              No pending tokens or allotments found for this lead.
                            </div>
                          ) : (
                            <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
                              {pendingDues.tokens.map((t) => (
                                <div
                                  key={t.paymentId}
                                  style={{
                                    background: "#EEEDFE",
                                    borderRadius: "0.6rem",
                                    padding: "0.6rem 1rem",
                                  }}
                                >
                                  <LeadStatusChip
                                    label={"Token"}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#3C3489", backgroundColor: "#fff" }}
                                  />
                                  <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#475467", marginTop: "0.4rem" }}>
                                    {t.tokenNumber || "-"} · owes ₹{numberWithCommas((t.amount || 0) - (t.paidAmount || 0))} · {t.status}
                                  </div>
                                </div>
                              ))}
                              {pendingDues.allotments.map((a) => (
                                <div
                                  key={a.allotmentPaymentId}
                                  style={{
                                    background: "#E6F1FB",
                                    borderRadius: "0.6rem",
                                    padding: "0.6rem 1rem",
                                  }}
                                >
                                  <LeadStatusChip
                                    label={"Allotment"}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#0C447C", backgroundColor: "#fff" }}
                                  />
                                  <div style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#475467", marginTop: "0.4rem" }}>
                                    Due for {a.dueFor} · owes ₹{numberWithCommas(a.dueAmount)} · {a.status}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Timeline>
            </div>

            {/* Footer */}
            <div className={cssClasses.footerWrapper}>
              {!detailTransaction?.tagged && !detailTransaction?.refunded ? (
                <Button
                  btnName={"Manual Tag"}
                  clicked={() => {
                    setSelectedTransaction(detailTransaction);
                    setTransactionDetailModal(false);
                    setManualTagModal(true);
                  }}
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                  }}
                  disable={
                    pendingDuesLoading ||
                    (pendingDues.tokens.length === 0 && pendingDues.allotments.length === 0)
                  }
                />
              ) : (
                <div />
              )}
              <Button
                btnName={"Close"}
                clicked={() => {
                  setTransactionDetailModal(false);
                  setDetailTransaction(null);
                }}
                style={{
                  color: "#344054",
                  backgroundColor: "#fff",
                  border: "1px solid #D0D5DD",
                }}
              />
            </div>
          </Box>
        </Modal>
      )}

      <Modal
        open={viewModal}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleViewClose();
          }
        }}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box className={cssClasses.wrapperModal}>
          <div className={cssClasses.paymentDetailsWrapperHeader}>
            <span>Payment Details</span>
            <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
            {loggedInUser && loggedInUser.roleId.title === "Super Admin" && (
            <button
              onClick={async () => {
                try {
                  let transactions = openTab === "Tokens" ? tokenTransactions : allotmentTransaction;

                  if (!transactions || transactions.length === 0) {
                    if (openTab === "Tokens") {
                      const paymentId = selectedCard?.viewDetails?.paymentid || selectedCard?.viewDetails?.paymentId;
                      if (!paymentId) { errorTost("Payment id not found."); return; }
                      const resp = await getTokenTransactions(paymentId);
                      transactions = Array.isArray(resp) ? resp : [];
                      setTokenTransaction(transactions);
                    } else {
                      const allotmentPaymentId = selectedCard?.viewDetails?.allotmentpaymentid || selectedCard?.viewDetails?.allotmentPaymentId;
                      if (!allotmentPaymentId) { errorTost("Allotment payment id not found."); return; }
                      const resp = await getAllotmentTransactionsTimeline(allotmentPaymentId);
                      transactions = Array.isArray(resp) ? resp : [];
                      setAllotmentTransaction(transactions);
                    }
                  }

                  if (!transactions || transactions.length === 0) {
                    infoTost("No transaction data found for Excel download.");
                    return;
                  }

                  downloadAllotmentExcel({
                    allotmentTransaction: transactions,
                    leadName: selectedCard.viewDetails?.leadName,
                    uniqueLeadId: selectedCard.viewDetails?.uniqueLeadId,
                    projectName: selectedCard.viewDetails?.projectName,
                    wingName: selectedCard.viewDetails?.wingName,
                    unitType: selectedCard.viewDetails?.unittype,
                    wingUnit: selectedCard.viewDetails?.wingUnit
                  });
                } catch (err) {
                  console.error("Excel download error:", err);
                  errorTost("Something went wrong while downloading Excel.");
                }
              }}

              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
                padding: "6px",
              }}
            >
              <DownloadIcon style={{ fontSize: "22px", color: "#1976d2" }} />
            </button>
            )}
            <CloseIcon
              fontSize="large"
              onClick={handleViewClose}
              style={{ cursor: "pointer" }}
            />
            </div>
          </div>




          <div className={cssClasses.paymentDetailsWrapper}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              {console.warn({ details, itemCont })}
              {selectedCard.viewDetails?.leadName && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    marginRight: "1rem",
                    gap: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <span className={cssClasses.leadName}>
                    {selectedCard.viewDetails?.leadName}
                  </span>
                  <span className={cssClasses.leadId}>
                    {"VJ" +
                      selectedCard.viewDetails?.uniqueLeadId?.replace(
                        selectedCard.viewDetails?.uniqueLeadId?.substring(
                          8,
                          12
                        ),
                        "-" +
                        selectedCard.viewDetails?.uniqueLeadId?.substring(
                          8,
                          12
                        )
                      )}
                  </span>
                </div>
              )}
              {openTab === "Tokens" &&
                selectedCard?.viewDetails?.linkedtokenid === null &&
                selectedCard.viewDetails?.status === "pending" ? (
                <LeadStatusChip
                  label={selectedCard.viewDetails?.status}
                  style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              ) : openTab === "Tokens" &&
                selectedCard?.viewDetails?.linkedtokenid === null &&
                selectedCard.viewDetails?.status === "alloted" ? (
                <LeadStatusChip
                  label={selectedCard.viewDetails?.status}
                  style={{ color: "#C01048", backgroundColor: "#FFF1F3" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              ) : openTab === "Tokens" &&
              selectedCard?.viewDetails?.linkedtokenid === null &&
              selectedCard.viewDetails?.status === "expired" && (
                <LeadStatusChip
                  label={selectedCard.viewDetails?.status}
                  style={{ color: "#B54708", backgroundColor: "#FFF4ED" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
              {openTab === "Tokens" &&
                selectedCard?.viewDetails?.linkedtokenid === null &&
                selectedCard.viewDetails?.status === "refund rejected" ? (
                <LeadStatusChip
                  label={selectedCard.viewDetails?.status}
                  style={{ color: "#FF4405", backgroundColor: "#FFE6D5" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              ) : openTab === "Tokens" &&
                selectedCard?.viewDetails?.linkedtokenid === null &&
                selectedCard.viewDetails?.status === "refunded" ? (
                <LeadStatusChip
                  label={selectedCard.viewDetails?.status}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              ) : openTab === "Tokens" &&
                selectedCard?.viewDetails?.linkedtokenid === null &&
                selectedCard.viewDetails?.status === "refund requested" ? (
                <LeadStatusChip
                  label={selectedCard.viewDetails?.status}
                  style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              ) : openTab === "Tokens" &&
                selectedCard?.viewDetails?.linkedtokenid === null &&
                selectedCard.viewDetails?.status === "refund initiated" ? (
                <LeadStatusChip
                  style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                  label={selectedCard.viewDetails?.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              ) : openTab === "Tokens" &&
                selectedCard?.viewDetails?.linkedtokenid === null &&
                selectedCard.viewDetails?.status === "active" ? (
                <LeadStatusChip
                  label={selectedCard.viewDetails?.status}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              ) : openTab === "Tokens" &&
                selectedCard?.viewDetails?.linkedtokenid === null &&
                selectedCard.viewDetails?.status === "refund processed" ? (
                <LeadStatusChip
                  label={selectedCard.viewDetails?.status}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              ) : openTab === "Tokens" &&
                selectedCard?.viewDetails?.linkedtokenid !== null &&
                selectedCard.viewDetails?.status !== "expired" && selectedCard.viewDetails?.status === "active" ? (
                <LeadStatusChip
                  label={"Upgraded"}
                  style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              ) : openTab === "Tokens" &&
                selectedCard?.viewDetails?.linkedtokenid !== null &&
                selectedCard.viewDetails?.status === "expired" ? (
                <LeadStatusChip
                  label={selectedCard.viewDetails?.status}
                  style={{ color: "#B54708", backgroundColor: "#FFF4ED" }}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )
                // : (
                //   openTab === "Tokens" && (
                //     <LeadStatusChip
                //       label={selectedCard.viewDetails?.status}
                //       style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                //       icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                //     />
                //   )
                // )}
                : ""}
              {openTab !== "Tokens" && (
                <LeadStatusChip
                  label={selectedCard.viewDetails?.status}
                  style={
                    selectedCard.viewDetails?.status === "pending"
                      ? { color: "#B54708", backgroundColor: "#FFFAEB" }
                      : selectedCard.viewDetails?.status === "complete"
                        ? { color: "#027A48", backgroundColor: "#ECFDF3" }
                        : { color: "#B54708", backgroundColor: "#FFF4ED" }
                  }
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
            </div>
            <div className={cssClasses.wrapperDetailsTimeLine}>
              <div className={cssClasses.containerPaymentDetails}>
                {/* <div className={cssClasses.projectName}>
              <span style={{    color: '#344054'}}>Project Name: </span>
            {selectedCard.viewDetails?.projectName}
            </div> */}
                {selectedCard.viewDetails?.tokenname && (
                  <>
                    <div className={cssClasses.projectName}>
                      VJ{selectedCard.viewDetails?.tokennumber}|{" "}
                      {selectedCard.viewDetails?.tokenname}{" "}
                    </div>
                    <div className={cssClasses.projectName}>
                      {selectedCard.viewDetails?.eventname}
                    </div>
                  </>
                )}
                {openTab !== "Tokens" && (
                  <div className={cssClasses.projectName}>
                    {selectedCard.viewDetails?.wingUnit} |
                    {selectedCard.viewDetails?.wingName} |
                    {selectedCard.viewDetails?.unittype} |
                    {selectedCard.viewDetails?.projectName}
                  </div>
                )}
                {openTab === "Tokens" ? (
                  <>
                    <div
                      className={cssClasses.projectName}
                      style={{ fontWeight: "600" }}
                    >
                      <span style={{ color: "#667085" }}>Token Amount : </span>₹
                      {selectedCard.viewDetails?.amount?.toLocaleString()}
                    </div>
                    <div
                      className={cssClasses.projectName}
                      style={{ fontWeight: "600" }}
                    >
                      <span style={{ color: "#667085" }}>Paid Amount : </span>₹
                      {selectedCard.viewDetails?.paidamount?.toLocaleString()}
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className={cssClasses.projectName}
                      style={{ fontWeight: "600" }}
                    >
                      <span style={{ color: "#667085" }}> Amount : </span>₹
                      {selectedCard.viewDetails?.amount?.toLocaleString() ||
                        selectedCard.viewDetails?.bookingamt?.total.toLocaleString()}
                    </div>
                    <div
                      className={cssClasses.projectName}
                      style={{ fontWeight: "600" }}
                    >
                      <span style={{ color: "#667085" }}>Paid Amount : </span>₹
                      {selectedCard.viewDetails?.paidamount?.toLocaleString()}
                    </div>
                    <div
                      className={cssClasses.projectName}
                      style={{ fontWeight: "600" }}
                    >
                      <span style={{ color: "#667085" }}>Unit Amount : </span>₹
                      {selectedCard.viewDetails?.unittotalcost?.toLocaleString()}
                    </div>
                  </>
                )}
                {openTab !== "Tokens" ? (
                  <div className={cssClasses.projectName}>
                    <span style={{ color: "#667085" }}>Bought on: </span>
                    {new Date(
                      selectedCard.viewDetails?.allotmentdate
                    ).toDateString()}
                    ,{" "}
                    {new Date(
                      selectedCard.viewDetails?.allotmentdate
                    ).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </div>
                ) : (
                  <div className={cssClasses.projectName}>
                    <span style={{ color: "#667085" }}>Bought on: </span>
                    {new Date(
                      selectedCard.viewDetails?.createdat
                    ).toDateString()}
                    ,{" "}
                    {new Date(
                      selectedCard.viewDetails?.createdat
                    ).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </div>
                )}
                {/* {selectedCard.viewDetails?.transactionId && (
                <div className={cssClasses.projectName}>
                  <span style={{ color: "#667085" }}>Transaction Id: </span>
                  {selectedCard.viewDetails?.transactionId}
                </div>
              )} */}
                {selectedCard.viewDetails?.paymentMethod && (
                  <div className={cssClasses.projectName}>
                    <span style={{ color: "#667085" }}>Payment Method:</span>
                    {selectedCard.viewDetails?.paymentMethod}
                  </div>
                )}
                {selectedCard.viewDetails?.virtualaccdetails !== null &&
                  openTab !== "Tokens" &&
                  selectedCard.viewDetails?.paymentMethod === "Virtual acc" && (
                    <>
                      <div className={cssClasses.projectName}>
                        <span style={{ color: "#667085" }}>
                          Beneficiary Name:{" "}
                        </span>
                        {
                          selectedCard.viewDetails?.virtualaccdetails
                            ?.bankBeneficiaryName
                        }
                      </div>
                      <div className={cssClasses.projectName}>
                        <span style={{ color: "#667085" }}>
                          Account Number:{" "}
                        </span>
                        {
                          selectedCard.viewDetails?.virtualaccdetails
                            ?.bankAccountNumber
                        }
                      </div>
                      <div className={cssClasses.projectName}>
                        <span style={{ color: "#667085" }}>IFSC Code: </span>
                        {
                          selectedCard.viewDetails?.virtualaccdetails
                            ?.bankIFSCCode
                        }
                      </div>
                      <div className={cssClasses.projectName}>
                        <span style={{ color: "#667085" }}>Bank UPI Id: </span>
                        {selectedCard.viewDetails?.virtualaccdetails?.bankUpiId}
                      </div>
                    </>
                  )}
              </div>
              <Box
                marginLeft={"auto"}
                style={{ height: " 32rem", overflowY: "auto" }}
              >
                {timeLine}
              </Box>
            </div>
          </div>
        </Box>
      </Modal>













      {showRefundConfirmationAlert && (
        <ConfirmationAlert
          confirm={(e) => {
            setShowRefundConfirmationAlert(false)
            if (e === "confirmed") {
              handleRefund()
            }
          }}
          buttonTitle={"No"}
          returnRespButton={"Yes"}
          close={() => setShowRefundConfirmationAlert(false)}
          title={"Warning"}
          subTitle={`Are you sure! Do you want to refund this transaction ?`}
          open={showRefundConfirmationAlert}
        />
      )}
      {showAutotagConfirmationModal && (
        <ConfirmationAlert
          confirm={(e) => {
            setShowAutotagConfirmationModal(false)
            if (e === "confirmed") {
              handleAutotagTransaction()
            }
          }}
          buttonTitle={"No"}
          returnRespButton={"Yes"}
          close={() => setShowAutotagConfirmationModal(false)}
          title={"Warning"}
          subTitle={`Are you sure! Do you want to auto-tag this transaction ?`}
          open={showAutotagConfirmationModal}
        />
      )}
      {manualTagModal && (
        <ManualTagModal
          open={manualTagModal}
          transaction={selectedTransaction}
          handleClose={() => {
            setManualTagModal(false);
            setSelectedTransaction();
          }}
          returnRes={(success) => {
            if (success) {
              setPageMaintain(0);
              setPageNumber(0);
              getTransactionPagination(
                0,
                searchValueTransaction?.current,
                filterByTransaction,
                selectDates,
                false
              );
            }
          }}
        />
      )}
      {refundTokenModal && (
        <RefundToken
          open={refundTokenModal}
          handleClose={() => {
            setRefundTokenModal(false);
          }}
          refundTokenData={refundTokenData}
          data={leadObj}
          returnRes={(value) => {
            if (value) {
              setSearch("");
              if (plans.length > 0 || planDetail.length > 0) {
                document.getElementById(
                  "input-with-icon-textfield userSearchBar"
                ).value = "";
              }
              setPlanDetail([]);
              getPlans("", "", filterBy, checked, from, to, selectBulk);
            }
          }}
        />
      )}
      {assignNewTokenModal && (
        <AssignNewToken
          open={assignNewTokenModal}
          handleClose={() => {
            setAssignNewTokenModal(false);
          }}
          oldTokenData={oldTokenData}
          data={leadObj}
          returnRes={(value) => {
            setSearch("");
            if (value) {
              if (plans.length > 0 || planDetail.length > 0) {
                document.getElementById(
                  "input-with-icon-textfield userSearchBar"
                ).value = "";
              }
              setPlans([]);
              setPlanDetail([]);
              getPlans("", "", filterBy, checked, from, to, selectBulk);
            }
          }}
        />
      )}

      {openAlertBoxForCancellation && (
        <RefundAllotment
          open={openAlertBoxForCancellation}
          handleClose={() => {
            setOpenAlertBoxForCancellation(false);
          }}
          data={leadObj}
          returnRes={(value) => {
            if (value) {
              setOpenAlertBoxForCancellation(false)
              setSearch("");
              setDepQuery(depStr + Math.random());
              setPlanDetail([]);
              setPlans([]);
              getPlans("", "", filterBy, checked, from, to, selectBulk);
              if (allotmentTransactions.length > 0) {
                document.getElementById(
                  "input-with-icon-textfield userSearchBar"
                ).value = "";
              }
            }
          }}
          allotmentData={oldAllotmentData}
          allotmentTransaction={allotmentTransaction.filter(
            (el) => el.status === "complete"
          )}
        />
      )}
      {alotUnitModal && (
        <AlotUnit
          open={alotUnitModal}
          handleClose={() => {
            setAlotUnitModal(false);
          }}
          data={leadObj}
          returnRes={(value) => {
            if (value === "back") {
              setAlotExistingUnitModal(true);
              // ! vedashree changes for pbc event preselect rebooking
              sessionStorage.setItem('isPaymentTab', true)
              setAlotUnitModal(false);
            }
          }}
          oldAllotmentData={oldAllotmentData}
          backArrowShow={true}
          isPaymentTab={true}
        />
      )}
      {alotExistingUnitModal && (
        <AlotExistingUnit
          open={alotExistingUnitModal}
          handleClose={() => {
            setAlotExistingUnitModal(false);
            // // ! vedashree changes for pbc event preselect rebooking
            // sessionStorage.removeItem('isPaymentTab')
          }}
          data={leadObj}
          returnRes={(value) => {
            if (value === "alotUnit") {
              setAlotExistingUnitModal(false);
              // ! vedashree changes for pbc event preselect rebooking
              sessionStorage.setItem('isPaymentTab', true)
              setAlotUnitModal(true);
            } else if (value === "adjustAlotDone") {
              setAlotExistingUnitModal(false)
              setSearch("");
              setDepQuery(depStr + Math.random());
              setPlanDetail([]);
              setPlans([]);
              getPlans("", "", filterBy, checked, from, to, selectBulk);
              if (allotmentTransactions.length > 0) {
                document.getElementById(
                  "input-with-icon-textfield userSearchBar"
                ).value = "";
              }
            }
          }}
          oldAllotmentData={oldAllotmentData}
          transactionsFound={allotmentTransaction.filter(
            (el) => el.status === "complete"
          )}
        />
      )}
    </div>
    // </QueryClientProvider>
  );
};

export default Payment;

const StatusChip = (params) => {
  if (params.value === "complete") {
    return (
      <LeadStatusChip
        label={"Complete"}
        style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "pending") {
    return (
      <LeadStatusChip
        label={"Pending"}
        style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "refund rejected") {
    return (
      <LeadStatusChip
        label={"Refund Rejected"}
        style={{ color: "#FF4405", backgroundColor: "#FFE6D5" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "refund requested") {
    return (
      <LeadStatusChip
        label={"Refund requested"}
        style={{ color: "#C11574", backgroundColor: "#FDF2FA" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "alloted") {
    return (
      <LeadStatusChip
        label={"Alloted"}
        style={{ color: "#C01048", backgroundColor: "#FFF1F3" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "expired") {
    return (
      <LeadStatusChip
        label={"Expired"}
        style={{ color: "#B54708", backgroundColor: "#FFF4ED" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "partial") {
    return (
      <LeadStatusChip
        label={"Partial"}
        style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "Released") {
    return (
      <LeadStatusChip
        label={"Released"}
        style={{
          color: "rgb(180, 35, 24)",
          backgroundColor: "rgb(254, 243, 242)",
        }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "Partial Payment Done") {
    return (
      <LeadStatusChip
        label={"Partial Payment Done"}
        style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "Cancelled" || params.value === "cancelled") {
    return (
      <LeadStatusChip
        label={"Cancelled"}
        style={{ color: "#C01048", backgroundColor: "#FFF1F3" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "On Hold") {
    return (
      <LeadStatusChip
        label={"On Hold"}
        style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "Cancellation Pending") {
    return (
      <LeadStatusChip
        label={"Cancellation Pending"}
        style={{ color: "#FF4405", backgroundColor: "#FFE6D5" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "Payment Pending") {
    return (
      <LeadStatusChip
        label={"Payment Pending"}
        style={{ color: "#C11574", backgroundColor: "#FDF2FA" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "Cancellation Requested") {
    return (
      <LeadStatusChip
        label={"Cancellation Requested"}
        style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "Upgraded") {
    return (
      <LeadStatusChip
        label={params.value}
        style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  } else if (params.value === "Agreement Done") {
    return (
      <LeadStatusChip
        label={params.value}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
        style={{
          color: "#0f70ea",
          backgroundColor: "#eef8ff",
        }}
      ></LeadStatusChip>
    );
  } else {
    return (
      <LeadStatusChip
        label={params.value}
        style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
      />
    );
  }
};
